(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
$(document).ready(function () {

    $(window).resize(function () {
        $checkWidth = $(window).width();

        if ($checkWidth > 767) {
            $("aside ul").css("display", "block");
        } else {
            $("aside ul").css("display", "none");
        }
    });

    $("aside h3").click(function () {
        if ($(window).width() < 768) {
            $(this).next("ul").slideToggle();
            $(this).children("span").toggleClass("arrow-down arrow-up");
        }
    });

    //Filter the notices
    $('.notice-block select').on('change', function () {
        const selectedType = $(this).val();
        const block = $(this).closest('.notice-block');
        const table = block.find('.infopost-table');
        const tableBody = table.find('tbody');
        const showMaxRows = parseInt(table.attr('data-tablemaxrow'), 10);

        // Get all notice types from dropdown (excluding "Latest..." options)
        const allOptions = $(this).find('option').map(function () {
            return $(this).val();
        }).get();

        const noticeTypes = selectedType.startsWith("Latest")
            ? allOptions.filter(opt => !opt.startsWith("Latest"))
            : [selectedType];

        if (selectedType.startsWith("Latest")) {
            fetchNotices(noticeTypes, showMaxRows, tableBody);
        } else {
            fetchNotices(noticeTypes, null, tableBody);
        }

    });

    // Handle static notice blocks (no dropdown, but has data-noticetype)
    $('.notice-block').each(function () {
        const block = $(this);
        const table = block.find('.infopost-table');
        const tableBody = table.find('tbody');
        const showMaxRows = parseInt(table.attr('data-tablemaxrow'), 10);

        const $select = block.find('select');
        if ($select.length > 0) {
            const selectedVal = $select.val();
            if (selectedVal && selectedVal.startsWith("Latest")) {
                $select.trigger('change');
            }
        } else {
            const staticType = block.find('[data-noticetype]').data('noticetype');
            if (staticType) {
                fetchNotices([staticType], showMaxRows, tableBody);
            }
        }
    });

    //Accordion row
    $('.infopost-table tbody').on('click', 'a', function () {
        const row = $(this).closest('tr');
        const tooltipRow = row.next('.notice-info-tooltip');
        $('.notice-info-tooltip').not(tooltipRow).hide();
        tooltipRow.toggle();
    });

    function fetchNotices(noticeTypes, showMaxRows, tableBody) {
        const requestData = {
            noticeTypes: noticeTypes
        };

        if (showMaxRows !== null && showMaxRows !== undefined) {
            requestData.showMaxRows = showMaxRows;
        }

        $.ajax({
            url: '/api/sitecore/InfoPost/GetNotices',
            method: 'POST',
            traditional: true,
            data: requestData,
            success: function (data) {
                if (data.error) {
                    tableBody.html(`<tr><td colspan="3" class="empty-results">Error while loading notices: ${data.error}</td></tr>`);
                    return;
                }

                if (!data || data.length === 0) {
                    const emptyMessage = $('.empty-results-table').text().trim();
                    tableBody.html(`<tr class="no-matching-notices"><td colspan="3" class="empty-results">${emptyMessage}</td></tr>`);
                    return;
                }

                data.sort((a, b) => new Date(b.PlannedDate) - new Date(a.PlannedDate));

                const rows = data.map(n => `
                <tr>
                    <td>${n.NoticeType}</td>
                    <td><a href="javascript:void(0)" class="toggle-details">${n.Subject}</a></td>
                    <td>${n.PlannedDate}</td>
                </tr>
                <tr class="notice-info-tooltip" style="display:none;">
                    <td colspan="3">
                        <a href="javascript:void(0)" class="close-selector" id="desktopCloseSelector" style="float: right;">
                            <i class="fa fa-times" aria-hidden="true" style="color: #000; text-decoration: none; font-size: 1.2rem;"></i>
                        </a>
                        <h4>${n.Subject}</h4>
                        <p>Posted: ${n.PlannedDate}</p>
                        <div>${decodeHtmlEntities(n.Details)}</div>
                    </td>
                </tr>
            `).join('');

                tableBody.html(rows);
            },
            error: function () {
                tableBody.html('<tr><td colspan="3">Error loading notices.</td></tr>');
            }
        });
    }

    function decodeHtmlEntities(str) {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }

});
},{}],2:[function(require,module,exports){
$(document).ready(function () {

    $(".capAndTradeClear").click(function () {
        $("#rate").val('');
        $("#totalResults").css("display", "none");
        $("#invalid").css("display", "none");
        $("#required").css("display","none");
    });

    $("#calculate").click(function (e) {

        var txtRate = $("#rate").val();
        var invalidcode = $("#invalidrate").attr('value');
        var requiredvalue = $("#requiredValue").attr('value');
        if (txtRate == '') {
            $('#required').text(requiredvalue);
            $("#totalResults").css("display", "none");
            $("#required").css("display", "block");
            $('#invalid').text('');
            return false;
        }
        else if ($.isNumeric(txtRate) && txtRate > 0) {
            var actual = $("#actual").val();
            var result = txtRate * actual;
            result = parseFloat(result, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            $('#calculator').html(result);
            $("#totalResults").css("display", "block");
            $('#invalid').text('');
            $('#required').text('');
        }
        else {
            $('#calculator').html('');
            $('#required').html('');
            $('#invalid').text(invalidcode);
            $("#invalid").css("display", "block");
            $("#totalResults").css("display", "none");
        }
    });
})
},{}],3:[function(require,module,exports){
var GlobalNotification = (function () {

    function GlobalNotification(globalNotificationConfig) {
        this.cancelNotification = globalNotificationConfig.cancelNotification;
        this.closeNotification = globalNotificationConfig.closeNotification;
        this.confirmNotification = globalNotificationConfig.confirmNotification;
        this.saveNotificationApiUrl = globalNotificationConfig.saveNotificationApiUrl;
        this.showNotification = globalNotificationConfig.showNotification;
        this.notificationItemId = globalNotificationConfig.notificationItemId;
        this.notificationPopupId = globalNotificationConfig.notificationPopupId;
    }

    GlobalNotification.prototype.initialize = function () {
        var notifications = this;

        $(notifications.notificationPopupId).modal({ backdrop: "static", keyboard: false, show: true });

        if (this.showNotification === "False") {
            window.showNotification = false;
        }
        $(document).on("click", this.confirmNotification, function (e) {
            $(notifications.notificationPopupId).modal('toggle');
           
             $.ajax({
                url: notifications.saveNotificationApiUrl,
                type: "POST",
                data: { notificationItemId: notifications.notificationItemId, "__RequestVerificationToken": $("input[name=__RequestVerificationToken]").val() },
                success: function (result) {
                    window.showNotification = false;
                    if (window.success) {
                        location.href = window.successPagePath;
                    }
                    else if (window.error) {
                        location.href = window.errorPage;
                    }
                },
                error: function (data) {
                    console.log("global notifications error", data);
                }
             });

        });

        $(document).on("click", this.closeNotification, function (e) {
            $(notifications.notificationPopupId).modal('toggle');
            window.showNotification = false;
            if(window.success)
            {
                location.href = window.successPagePath;
            }
            else if (window.error)
            {
                location.href = window.errorPage;
            }
        });

        $(document).on("click", this.cancelNotification, function (e) {
            $(notifications.notificationPopupId).modal('toggle');
            window.showNotification = false;
            if (window.success) {
                location.href = window.successPagePath;
            }
            else if (window.error) {
                location.href = window.errorPage;
            }
        });
    };

    return GlobalNotification;
}());

$(document).ready(function () {

    if ($("#loadingPage").length > 0) {
        var globalNotificationConfig = {
            cancelNotification: "#cancelNotification",
            closeNotification: "#closeNotification",
            confirmNotification: "#confirmNotification",
            saveNotificationApiUrl: "/api/sitecore/Notifications/SaveNotificationInCookie",
            notificationItemId: window.notificationSettings.notificationContentId,
            showNotification: window.notificationSettings.showNotification,
            notificationPopupId: "#notificationModalPopup"
        };
        var globalNotification = new GlobalNotification(globalNotificationConfig);
        globalNotification.initialize();
    }
});
},{}],4:[function(require,module,exports){

$(document).ready(function () {
    if ($('#bus_login').length) {
        if (localStorage.loginType !== undefined && localStorage.loginType !== "selected") {
            $('#select', $('#bus_login')).val(localStorage.loginType);
            switchLogin(localStorage.loginType);
        }
    }


    $('#signin_box2').click(function () {
        UnionlineLogin();
        return false;
    });
    $('#errorBox').css('display', 'none');
    $('#errorLabel').empty();

    $('#select').on('change', function () {
        localStorage.setItem("loginType", this.value);
        //  alert( this.value ); // or $(this).val()
        switchLogin(this.value)
    });

});
function switchLogin(loginType) {
    if (loginType == "selected") {
        $('#box1').hide();
        $('#box2').hide();
        $('#box3').hide();
        $('#box4').hide();
        $('#box5').hide();
    }
    else if (loginType == "myAccount") {
        $('#box1').show();
        $('#box2').hide();
        $('#box3').hide();
        $('#box4').show();
        $('#box5').hide();
    }
    else if (loginType == "enerLine") {
        $('#box1').hide();
        $('#box2').show();
        $('#box3').hide();
        $('#box4').hide();
        $('#box5').hide();
    }
    else if (loginType == "getConnected") {
        $('#box1').hide();
        $('#box2').hide();
        $('#box3').show();
        $('#box4').hide();
        $('#box5').show();

    } else {
        $('#box1').hide();
        $('#box2').hide();
        $('#box3').hide();
        $('#box4').hide();
        $('#box5').hide();

    }
}
function UnionlineLogin() {
    args = {
        UserName: document.getElementById('username').value,
        Password: document.getElementById('pwd').value,
    };

    var submission = mySubmit(args);
    if (submission) {
        var days = 30;
        var myDate = new Date();
        myDate.setTime(myDate.getTime() + (days * 864000));
        document.cookie = 'cookieName=UnionlineLogin; Domain=uniongas.com; Path=/; expires=' + myDate.toGMTString();
        jQuery.postToUrl(document.getElementById("hdnUnionlinePostBackUrl").value, args, { openNewWindow: true });

        document.getElementById('username').value = '';
        document.getElementById('pwd').value = '';
    }

    return false;
}

function mySubmit(args) {
    if (args.UserName != "" & args.Password != "") {
        $('#errorBox').css('display', 'none');
        $('#errorLabel').empty();
        return true;
    }
    else {
        $('#errorBox').css('display', 'block');
        $('#errorLabel').text($('#hdnUnionlineSignInError').val());
        return false;
    }
}

(function ($) {

    //
    // Default options for the postToUrl method
    //
    var POST_TO_URL_DEFAULTS = {
        method: 'POST',
        openNewWindow: false
    };

    //
    // Post a dynamic form to a URL.
    // Dynamically builds a form with the given hidden fields and posts it to the given url.
    //
    $.postToUrl = function (url, args, options) {
        options = $.extend({}, POST_TO_URL_DEFAULTS, options);

        var $form = $('<form></form>').hide().attr({ action: url, method: options.method }),
            $input = $('<input></input>').attr({ type: 'hidden' }),
            value;

        // open in a new page
        if (options.openNewWindow) {
            $form.attr({ target: '_blank' })
        }

        // add all of the fields to the form
        for (var key in args) {
            if (args.hasOwnProperty(key)) {
                value = args[key];
                if (!$.isArray(value))
                    value = [value];

                $.each(value, function (index, item) {
                    $input.clone().attr({
                        name: key,
                        value: item
                    }).appendTo($form);
                });
            }
        }

        // submit the form
        $('body').append($form);
        $form.submit();
        $form.remove();
    }
})(jQuery);
},{}],5:[function(require,module,exports){
$(document).ready(function () {
    if ($(".chatbot-page-main").length > 0) {
        var container = document.querySelector('#chat-bot');
        if (container) {
            $(container).prependTo($(".main > .two-column-container > .container > .row > .col-md-4.col-lg-3"));
        }
        setTimeout(function () {
            if ($("#isChatBotActive").val() == "True") {                
                if (window.disableChat) {
                    var unsupportedBrowserContent = $("#unsupportedContent").val();
                    $(".chatbot-alert-maintenance").children().find("h4").html(unsupportedBrowserContent);
                    $("#chat-bot").hide();
                    $("#dvError").show();  
                }
                else {
                    $("#dvError").hide();  
                }
            }
            else {
                $("#dvError").show(); 
            }
        }, 250);
    }

    $(document).on("click", ".coze-wordmark", function (e) {
        e.preventDefault();
        if ($("#isChatBotActive").val() == "True") {
            var chatBotContainer = document.querySelector('#chat-bot');
            var open_converse = chatBotContainer.shadowRoot.querySelector("#open-converse");
            openConverse(open_converse);
        }
    });
});
},{}],6:[function(require,module,exports){
var tabbable_elements_selector = "a, input, button, textarea, select, .service-address-selector, .account-line";

$(document).ready(function () {

    //$('.header-top').prepend('<div class="skipToMainContentContainer"><a href="javascript:void(0)" class="skip-to-main-content">Skip to Main Content</a></div>');

    // make unique labels for sign-in input fields
    //if ($(".signin-username").length > 1) {
    //    $(".signin-username").each(function (index, e) {
    //        var base_id = "signin-username";
    //        var new_id = base_id + (index + 1);
    //        $(e).attr("id", new_id);
    //        $(e).siblings("label").attr("for", new_id);
    //    });
    //    $(".signin-password").each(function (index, e) {
    //        var base_id = "signin-password";
    //        var new_id = base_id + (index + 1);
    //        $(e).attr("id", new_id);
    //        $(e).siblings("label").attr("for", new_id);
    //    });
    //    $(".rememberme").each(function (index, e) {
    //        var base_id = "rememberme";
    //        var new_id = base_id + (index + 1);
    //        $(e).attr("id", new_id);
    //        $(e).closest("label").attr("for", new_id);
    //    });
    //}

    // add id to main content div to focus on upon skipping (for screen readers)
    var mainContentId = getMainContentId();
    $("body").attr("id", "back-to-top");
   
    var skipToContent = '<div class="skipToMainContentContainer"><a href="#' + $(mainContentId).attr('id') + '"  aria-label="Skip to main content" class="skip-to-main-content" role="button" tabindex="0">Skip to Main Content</a></div>'
    $('.header-static').prepend(skipToContent);
    // add id to tab content div to focus on upon clicking tab (for screen readers)
    if ($(".tab-content").length > 0) {
        $(".tab-content").each(function () {
            if ($(this).attr("id") == undefined || $(this).attr("id") == "") {
                $(this).attr("id", "tab-content");
            }
        });
    }

    $(".skip-to-main-content").click(function () {
        if ($(mainContentId).length == 0 || $(mainContentId).is(":hidden")) {
            mainContentId = getMainContentId();
        }
        if (window.location.hash == mainContentId) {
            window.location.hash = "";
        }
        $("html, body").animate({ scrollTop: $(mainContentId).offset().top }, 600)
            .promise().then(function () {
                window.location.hash = mainContentId;
            });
    });

    $(".myTab:not(#myTab):not(.faq) > li > a").click(function () {
        $("html, body").animate({ scrollTop: $("#tab-content").offset().top }, 600)
            .promise().then(function () {
                window.location.hash = "";
                window.location.hash = "tab-content";
            });
    });

    $("body").on("keydown keypress", function (e) {
        if (e.keyCode == 9) {
            activateHighlightOnTabPress();
        }
    });

    $("body").mousedown(function () {
        hideHighlightOnMouseClick();
    });

    $(".service-address-selector, .dropdown-toggle, .account-line, .skip-to-main-content, .back-to-top").on("keydown keypress", function (e) {
        if (e.keyCode == 32 || e.charCode == 32 || e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
            e.preventDefault();
            return false;
        }
    });
    $("a.accordianIcon").on("keydown keypress", function (e) {
        if (e.keyCode == 32 || e.charCode == 32) {
            e.preventDefault();
            return false;
        }
    });

    $(".service-address-selector, .skip-to-main-content").on("keyup", function (e) {
        var element = $(this);
        if (e.keyCode == 32 || e.charCode == 32 || e.keyCode == 13) {
            e.preventDefault();
            element.click();
        } else if (e.keyCode == 40) {
            e.preventDefault();
            element.click();
            element.closest(".address-container").find(".account-line").first().focus();
        }
    });

    $(".collapse-btn a, a.accordianIcon, .CoveoSearchButton").on("keyup", function (e) {
        var element = $(this);
        if (e.keyCode == 32 || e.charCode == 32 || e.keyCode == 13) {
            e.preventDefault();
            element.click();
        }
    });

    $(".back-to-top").keydown(function (e) {
        var element = $(this);
        if (e.keyCode == 32 || e.charCode == 32 || e.keyCode == 13) {
            e.preventDefault();
            element.click();
        }
    });

    /** spacebar and arrow-down keys to open mega menu **/
    $(".dropdown-toggle").on("keyup", function (e) {
        var element = $(this);
        if (e.keyCode == 32 || e.charCode == 32) {
            if (element.siblings("ul:eq(0)").hasClass("open-div")) {
                $(".dropdown-toggle").mouseleave();
            } else {
                $(".dropdown-toggle").mouseleave();
                element.mouseenter();
            }
        }
    });

    /** arrow navigation on mega menu dropdown buttons **/
    $(".dropdown-toggle").on("keydown keypress", function (e) {
        var element = $(this);
        if (e.keyCode == 37) {
            $(".dropdown-toggle").mouseleave();
            element.parent().prev().eq(0).find(".dropdown-toggle").focus().mouseenter();
        } else if (e.keyCode == 38) {
            $(".dropdown-toggle").mouseleave();
        } else if (e.keyCode == 39) {
            $(".dropdown-toggle").mouseleave();
            element.parent().next().eq(0).find(".dropdown-toggle").focus().mouseenter();
        } else if (e.keyCode == 40) {
            $(".dropdown-toggle").mouseleave();
            element.mouseenter();
            element.siblings("ul:eq(0)").find("a:eq(0)").focus();
        }
    });

    /** up, down, left, right arrows inside mega menu **/
    //$(".mega-dropdown-menu a").on("keydown keypress", function (e) {
    //    var element = $(this);
    //    var child = element[0];
    //    var parent = element.closest(".mega-dropdown-menu").find("a");
    //    var index = Array.prototype.indexOf.call(parent, child);
    //    if (e.keyCode == 37) {
    //        $(".dropdown-toggle").mouseleave();
    //        element.closest(".mega-dropdown").find(".dropdown-toggle").focus().parent().prev().eq(0).find(".dropdown-toggle").focus().mouseenter();
    //    } else if (e.keyCode == 38) {
    //        if (index == 0) {
    //            $(".dropdown-toggle").mouseleave();
    //            element.closest(".mega-dropdown-menu").siblings(".dropdown-toggle").focus();
    //        } else {
    //            parent[index - 1].focus();
    //        }
    //    } else if (e.keyCode == 39) {
    //        $(".dropdown-toggle").mouseleave();
    //        element.closest(".mega-dropdown").find(".dropdown-toggle").focus().parent().next().eq(0).find(".dropdown-toggle").focus().mouseenter();
    //    } else if (e.keyCode == 40) {
    //        if (index + 1 < parent.length) {
    //            parent[index + 1].focus();
    //        }
    //    }
    //});

    $(".service-address-selector").attr('tabindex', 0);
    //$(".account-line").attr('tabindex', 0);
});

function getMainContentId() {
    var mainContentId = "#main-content";
    if ($(".main-content").children().length > 0) {

        var firstTabIndexElems = $(".main-content").children("[tabindex='0']");
        if (firstTabIndexElems.length > 0) {
            var firstTabIndexElem = firstTabIndexElems[0];
            if (firstTabIndexElem.attr("id") == undefined || firstTabIndexElem.attr("id") == "") {
                firstElem.attr("id", "main-content");
            } else {
                mainContentId = "#" + firstTabIndexElem.attr("id");
            }
        }
        else {

            var a = document.createElement("a");
            a.id = "main-content";
            a.tabIndex = "0";
            a.role = "link";
            a.classList.add("sr-only");
            var aText = document.createTextNode("main content");
            a.appendChild(aText);

            var firstElem = $(".main-content").children(":not(.hidden-xs):not(script):not(:hidden)").first();
            firstElem.prepend(a);
        }
    }
    return mainContentId;
}

function activateHighlightOnTabPress() {
    $(tabbable_elements_selector).addClass("outline-on");
}

function hideHighlightOnMouseClick() {
    $(".outline-on").removeClass("outline-on");
}

},{}],7:[function(require,module,exports){
(function () {
    var interceptPersona = {
        InterceptFields: [],
        postalcode:""
    };
    var domainName = document.location.protocol + "//" + document.location.hostname;
    $(document).ready(function () {
        if ($('#interceptPop').length !== 0) {
            window.dialogServiceIntercept = null;
            window.dialogPersonalisationAlert = null;
            $('#interceptPop').on('shown.bs.modal', function () {
                window.dialogServiceIntercept = new Dialog($(this), null)
                window.dialogServiceIntercept.open();
            })
            $('#interceptPop').on('hidden.bs.modal', function (e) {
                if (window.dialogServiceIntercept != null) {
                    window.dialogServiceIntercept.close();
                    window.dialogServiceIntercept = null;
                }
            })
            $('#personalisationAlert').on('shown.bs.modal', function () {
                window.dialogPersonalisationAlert = new Dialog($(this), null)
                window.dialogPersonalisationAlert.open();
            })
            $('#personalisationAlert').on('hidden.bs.modal', function (e) {
                if (window.dialogPersonalisationAlert != null) {
                    window.dialogPersonalisationAlert.close();
                    window.dialogPersonalisationAlert = null;
                }
            })
            //Populate Data If present
            setPersonaValue();
            $('#personalisationAlert').css('display', 'none');
            $('#interceptPop').css('display', 'none');

            if (localStorage.isPersonalised == "true") {
                $('#interceptPop').modal('hide');
                $('#personalisationAlert').modal({});
                var timeoutDuration = parseInt($("#successModalTimeout").val()) * 1000;
                setTimeout(function () {
                    localStorage.removeItem("isPersonalised");
                    $('#personalisationAlert').modal('hide');
                }, timeoutDuration);
            }
            else {
                if ($('#showInterceptPop').val() === 'false')
                    $('#interceptPop').modal('hide');
                else
                    $('#interceptPop').modal({});
            }

            if ($(".identifiedServiceArea").val() === "LUG")
                $("#chk-personaToggler").prop('checked', true);

        }
    });
    window.Parsley.addValidator('validateDropdown', {
        validateString: function validateString(value, req, elem) {
            if (value === 'Select')
                $(elem.element).parent().addClass('error')
            else
                $(elem.element).parent().removeClass("error")

            return value !== 'Select';
        }
    });
    function validatePostalCode(postalCode) {
        var regexPostalCode = RegExp('[K-NP-Pk-np-p][0-9][A-Za-z]( |-|)[0-9][A-Za-z][0-9]');
        return regexPostalCode.test(postalCode);
    }
    window.Parsley.addValidator('validatePostalCode', {
        validateString: function validateString(postalCode, req, elem) {
            return validatePostalCode(postalCode);
        }
    });



    $('#postalcode').keyup(function (e) {
        var postalCode = $('#postalcode');
        var postalCodeValue = postalCode.val();
        var codeLength = postalCodeValue.length;
        if (codeLength < 4) {
            if (codeLength === 1) postalCode.attr("inputmode", "numeric"); else if (codeLength === 2) postalCode.attr("inputmode", "text"); else postalCode.attr("inputmode", "text");
        } else {
            if (postalCodeValue[3] === ' ' || postalCodeValue[3] === '-') {
                postalCode.attr("maxlength", "7");
                if (codeLength === 4) postalCode.attr("inputmode", "numeric"); else if (codeLength === 5) postalCode.attr("inputmode", "text"); else postalCode.attr("inputmode", "numeric");
            } else {
                postalCode.attr("maxlength", "6");
                if (codeLength === 4) {
                    postalCode.removeAttr("inputmode");
                    postalCode.attr("inputmode", "text");
                } else if (codeLength === 5) postalCode.attr("inputmode", "numeric");
            }
        }
        postalCode = null;
    });
    $(document).keydown(function (event) {
        if (event.keyCode == 27) {
            if ($('#interceptPop').length !== 0) {
                checkDefaultAndSave();
                $('#interceptPop').modal('hide');
            }
            if ($('#personalisationAlert').length !== 0) {
                localStorage.removeItem("isPersonalised");
                $('#personalisationAlert').modal('hide');
            }
        }
    });
    function generatePersonaValue(personaValue) {
        var res = personaValue.split("&");
        var refinedPersonaValue = {}
        res.forEach(function (data) {
            if (data.indexOf('=') !== -1) {
                var temp = data.split("=");
                if (temp[1].indexOf("@amp@") > 0) {
                    refinedPersonaValue[temp[0]] = temp[1].replace(/@amp@/g, '&');
                }
                else {
                    refinedPersonaValue[temp[0]] = temp[1];
                }
            }
        })
        return refinedPersonaValue;
    }
    function setPersonaValue() {
        if ($('#userInterceptPreferences').val() !== "" && $('#userInterceptPreferences').val() !== undefined && $("#frm-intercept").length !== 0) {
            var personaValue = generatePersonaValue($('#userInterceptPreferences').val());
            var inputFields = $("#frm-intercept").children(".form-group");
            inputFields.each(function () {
                if ($('select', this).length !== 0 && personaValue[$('input:hidden', this).val()]) {
                    $('select', this).val(personaValue[$('input:hidden', this).val()]);
                }
                if ($('input:text', this).length !==0 && personaValue[$('input:hidden', this).val()]) {
                    $('input:text', this).val(personaValue[$('input:hidden', this).val()]);
                }
            });
        }
    }
    function getPersonaValue() {
        if ($("#frm-intercept").length !== 0) {
            (function () {
                var inputFields = $("#frm-intercept").children(".form-group");
                var selectFields = [];
                inputFields.each(function () {
                    var temp = {};
                    if ($('select', this).length !== 0) {
                        temp.fieldName = $('input:hidden', this).val();
                        temp.fieldValue = $('select', this).val();
                        selectFields.push(temp);
                    }
                    if ($('input:text', this).length !== 0) {
                        var postalcode = $('input:text', this).val();
                        if (postalcode.indexOf(" ") != -1) {
                            postalcode = postalcode.split(" ");
                            postalcode = postalcode[0] + postalcode[1];
                        }
                        if (postalcode.indexOf("-") != -1) {
                            postalcode = postalcode.split("-");
                            postalcode = postalcode[0] + postalcode[1];
                        }
                        temp.fieldName = $('input:hidden', this).val();
                        temp.fieldValue = postalcode;
                        interceptPersona.postalcode = postalcode;
                        selectFields.push(temp);
                    }
                });
                interceptPersona.InterceptFields = [].concat(selectFields);
            })();
        }
    }
    function reloadCurrentPage(preference) {
        var rURL = document.location.href;
        if (preference === "user")
            localStorage.setItem("isPersonalised", "true");
        window.open(rURL, "_self");
    }
    function saveCookie(serviceArea) {
        var preference = arguments.length <= 1 || arguments[1] === undefined ? "user" : arguments[1];

        var requestURL = domainName + "/api/sitecore/ServiceIntercept/SubmitLegacyServiceInterceptForm";
        var requestData = {};
        requestData.__RequestVerificationToken = $("input[name=__RequestVerificationToken]").val();
        requestData.IdentifiedServiceArea = serviceArea;
        requestData.InterceptFields = interceptPersona.InterceptFields;
        $.ajax({
            'type': 'POST',
            'url': requestURL,
            'data': requestData,
            'success': function success(result, status, xhr) {
                if (xhr.readyState === 4 && xhr.status === 200 && result.toLowerCase() == "true") {
                    reloadCurrentPage(preference);
                }
            }
        });
    }
    function submitIntercept() {
        $("#frm-intercept").parsley().validate();
        if ($("#frm-intercept").parsley().isValid()) {
            getPersonaValue();
            var requestURL = domainName + "/api/sitecore/ServiceIntercept/GetServiceArea?postalcode=" + interceptPersona.postalcode;
            $.get(requestURL, function (data, status) {
                if (status === "success") {
                    if (data.IdentifiedServiceArea !== "LEG" && data.IdentifiedServiceArea !== "LUG") {
                        var errmsg = '<p id="warning-header">' + data.ErrorMessage + '</p><p id="warning-content">' + data.ErrorDescription + '</p>';
                        $("#warning-header").remove();
                        $("#warning-content").remove();
                        $("#warning-banner .warning section").prepend(errmsg);
                        $("#warning-banner").css("display", "flex");
                    } else {
                        saveCookie(data.IdentifiedServiceArea);
                    }
                }
            });
        }
    }
    $("#frm-intercept").submit(function (e) {
        submitIntercept();
        e.preventDefault();
    });
    $("#btn-LUG").click(function () {
        saveCookie("LUG");
    });
    $("#btn-LEG").click(function () {
        saveCookie("LEG");
    });
    function checkDefaultAndSave() {
        if ($(".identifiedServiceArea").val() == "") {
            saveCookie($("#defaultServiceArea").val(), "default");
        }
    }
    $('#btn-close-intercept').click(function () {
        checkDefaultAndSave();
    });
    $("#interceptPop").click(function (event) {
        if (this.id === event.target.id) {
            checkDefaultAndSave();
        }
    });
    $("#btn-banner-remove").click(function (event) {
        $("#warning-banner").css("display", "none");
    });
    $("#btn-close-personalisationAlert").click(function () {
        localStorage.removeItem("isPersonalised");
    });
    $("#personalisationAlert").click(function (event) {
        if (this.id === event.target.id) {
            localStorage.removeItem("isPersonalised");
        }
    });

    $("#btn-interceptLauncher").click(function () {
        $('#interceptPop').modal({});
    })
    $("#chk-personaToggler").click(function () {
        if ($(this).prop("checked") == true)
            saveCookie("LUG")
        else
            saveCookie("LEG")

    });

    $("#changeServiceID").click(function () {
        $('#crossButtonID').trigger('click');
        if ($("#isPostalOnlyServiceIntercept").val() == 'true') {
            if ($(".identifiedServiceArea").val() === "LUG")
                saveCookie("LEG")
            else
                saveCookie("LUG")
        } else {
            $('#interceptPop').modal({});
        }
    });
})();
},{}],8:[function(require,module,exports){
window.Dialog=function(dialogEl, focusedElBeforeOpen) {
    
    this.dialogEl = dialogEl;
    this.focusedElBeforeOpen = focusedElBeforeOpen;

    const focusableEls = $('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]', this.dialogEl);
    this.focusableEls = Array.prototype.slice.call(focusableEls);

    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    this.ariaHiddenFalseEle = null;
    //this.close(); // Reset
    this.calculateAriaHidden(this.dialogEl);
    this.calculateFocusableEl(this.dialogEl);
}
function removeSrOnlyFromTabOrder(dialogEl) {
    const sronly = $('.sr-only', dialogEl);
    for (var i = 0, length = sronly.length; i < length; i++) {
        sronly[i].setAttribute('tabindex', '-1');
    }
}
function setTabOrder(focusableEls) {
    const length = focusableEls.length;
    for (var i = 0; i < length; i++) {
        focusableEls[i].setAttribute('taborder', i + 1 + "");
    }
    return length;
}

function resetTabOrder() {
    const focusableEls = document.querySelectorAll('[taborder]');
    for (var i = 0, length = focusableEls.length; i < length; i++) {
        focusableEls[i].removeAttribute('taborder');
    }
}

Dialog.prototype.calculateFocusableEl = function (dialogEl) {
    removeSrOnlyFromTabOrder(dialogEl);
    const focusableElements = [];
    var focusableEls = $('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]', dialogEl);
    focusableEls.each(function (index, el) {
        if (el.offsetHeight > 0) {
            focusableElements.push(el);
        }
    });
    resetTabOrder();

    this.lastFocusableElIndex = setTabOrder(focusableElements);
    this.focusableEls = focusableElements;
}
Dialog.prototype.calculateAriaHidden = function (dialog) {
    this.ariaHiddenFalseEle = dialog.siblings(':not([aria-hidden=true])');   
}
Dialog.prototype.setfocusonFirstElement = function () {
    $(this.firstFocusableEl).addClass('outline-on');
    $(this.firstFocusableEl).focus();
}

Dialog.prototype.handleKeyDown = function (e) {
    const KEY_TAB = 9;
    const KEY_ESC = 27;
    this.calculateFocusableEl(this.dialogEl);
    const firstFocusableEl = $('[taborder="1"]', this.dialogEl);
    const lastFocusableEl = $('[taborder="' + this.lastFocusableElIndex + '"]', this.dialogEl);
    function handleBackwardTab() {
        if ($(document.activeElement)[0] === firstFocusableEl[0]) {
            e.preventDefault();
            lastFocusableEl.focus();
        }
    }

    function handleForwardTab() {
        if ($(document.activeElement)[0] === lastFocusableEl[0]) {
            e.preventDefault();
            firstFocusableEl.focus();
        }
    }

    switch (e.keyCode) {
        case KEY_TAB:
            if (this.focusableEls.length === 1) {
                e.preventDefault();
                break;
            }
            if (e.shiftKey) {
                handleBackwardTab();
            } else {
                handleForwardTab();
            }
            break;
        default:
            break;
    }
};
Dialog.prototype.open = function () {
    const DialogInstance = this;
    this.dialogEl.attr('aria-hidden', false);
    this.ariaHiddenFalseEle.attr('aria-hidden', true);
    this.setfocusonFirstElement();
    this.handleKeyDownEvent = function (e) {
        DialogInstance.handleKeyDown(e);
    };
    this.dialogEl.on('keydown', this.handleKeyDownEvent);
}
Dialog.prototype.close = function () {
    if (this.focusedElBeforeOpen != null)
        this.focusedElBeforeOpen.focus();
    if (this.dialogEl) {
        this.dialogEl.attr('aria-hidden', true);
        this.ariaHiddenFalseEle.attr('aria-hidden', false);
    }
        
}
},{}],9:[function(require,module,exports){
(function () {
    $("#btn-interceptLauncher").click(function () {
        $('#interceptPop').modal({});
    })
    if ($('#isInterceptEnabled').val() == "true") {
        if ($(".identifiedServiceArea").val() != "") {
            if ($("#isPostalOnlyServiceIntercept").val() == "true") {
                $("#personaToggler").css("display", "block")
            } else {
                $("#interceptLauncher").css("display", "block")
            }
        }
    }
})();
},{}],10:[function(require,module,exports){
function sanitizeURL(url) {
    try {
        var sanitizedURL = new URL(url, window.location.origin);
        return sanitizedURL.href;
    } catch (e) {
        console.error("Invalid URL:", url);
        return null;
    }
}
document.addEventListener("DOMContentLoaded", function () {
    const imgs = document.querySelectorAll(".state-selector img.img-responsive,img.logo, .footer-bottom img")
    imgs.forEach(img => {
        if (img.hasAttribute("src")) {
            img.setAttribute("data-src", img.getAttribute("src"));
            img.removeAttribute("src");
            img.classList.add("lazy");
        }
    });

    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (!img.hasAttribute("src")) {
                        const dataSrc = img.getAttribute("data-src");
                        const safeSrc = sanitizeURL(dataSrc);
                        if (safeSrc) {
                            img.setAttribute("src", safeSrc);
                        }
                        img.removeAttribute("data-src");
                        img.classList.remove("lazy");
                        obs.unobserve(img);
                    }
                }
            });
        });
        document.querySelectorAll("img.lazy").forEach(img => observer.observe(img));

    } else {
        document.querySelectorAll("img.lazy").forEach(img => {
            const dataSrc = img.getAttribute("data-src");
            const safeSrc = sanitizeURL(dataSrc);
            if (safeSrc) {
                img.setAttribute("src", safeSrc);
            }
            img.removeAttribute("data-src");
            img.classList.remove("lazy");
        });
    }
});
$(document).ready(function () {
    var $geoip = $('#geoip-enable').length
        ? ($('#geoip-enable').val() || '').toLowerCase()
        : '';
    var stateTitle = getCookie('stateTitle') || '';
    var cookieTitle = getCookie('cookieTitle') || '';
    var stateMiniTitle = getCookie('stateMiniTitle') || '';
    var selectedLang = getCookie('selectedLanguage') || '';
    var currentPageTitle = $('#current-page-title').length
        ? ($('#current-page-title').val() || '')
        : '';
    var cookieState = stateTitle
        ? stateTitle.toLowerCase()
        : '';
    var pageLocation = $('#page-location').length
        ? ($('#page-location').val() || '').toLowerCase()
        : '';
    var qcTitle = $("#manualLocationSelection a[data-location='QC']").length
        ? ($("#manualLocationSelection a[data-location='QC']").attr('data-location-title') || '').toLowerCase()
        : '';
    var qcHref = $("#manualLocationSelection a[data-location='QC']").length
        ? ($("#manualLocationSelection a[data-location='QC']").attr('href') || '').toLowerCase()
        : '';
    var currentPageUrl = window.location.href;
    var trimmedcurrentUrl = currentPageUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
    var hostname = window.location.hostname;
    var $selects = $('.location-dropdown-block select.location-selection-dropdown');
    const locationData = [];
    const locationminititleData = [];
    const locationtitleData = [];
    $(".my-state.state-selected").parent("button").css("border-bottom", "5px solid #FFB81C");
    $(".my-state.state-selected").parent("button").css("padding-bottom", "3px");
    $(".my-state.state-selected").parent("button").css("margin-bottom", "-5px");

    //Accessibility fix
    if ($selects.length > 1) {
        $selects.each(function (index) {
            var $select = $(this);

            if ($select.attr('aria-label')) {
                $select.attr('aria-label', 'Location selector ' + (index + 1));
            }
        });
    }

    //Prevent duplicate Alt tags from sitecore
    var altCounts = {};
    $('img[alt]').each(function () {
        const alt = $(this).attr('alt').trim();
        if (altCounts[alt]) {
            altCounts[alt]++;
            $(this).attr('alt', `${alt} ${altCounts[alt]}`);
        } else {
            altCounts[alt] = 1;
        }
    });

    //Desktop Geolocation dropdown show-hide
    $("#geolocationBtn").on("click", function () {
        if ($geoip === "true") {
            $.ajax({
                url: '/api/sitecore/GeoIP/GetLocationByIP',
                method: 'GET',
                success: function (data) {
                    $('#geoip-location').val(data.Region);
                    var fetchedregion = $('#geoip-location').val();
                    if (locationminititleData.includes(fetchedregion)) {
                        locationData.forEach(state => {
                            if (state.locationminititle === fetchedregion) {
                                $(".detected-location").text(state.locationtitle);
                                $(".go-to-site").attr("href", state.locationhref);

                                $(".go-to-site").on("click", function () {
                                    document.cookie = "stateTitle=" + state.locationtitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                    document.cookie = "stateMiniTitle=" + state.locationminititle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                    updateContent(state.locationtitle, state.locationminititle);
                                });
                            }
                        });
                        $('.geoip-detection .desktopLocationList a.state').each(function () {
                            var detectip = $(this).attr("data-location");
                            if (detectip === fetchedregion) {
                                $(this).addClass("hide");
                            }
                        });
                        $("#desktopLocationSelectorAuto").addClass("show");
                        $("#desktopLocationSelector").removeClass("show");
                        manualLocationDetection();
                        $('#manualLocationSelection .desktop-location-selection-new a[data-country="USA"]:not(.hide):last').css("margin-right", "0");
                    } else {
                        $("#desktopLocationSelector").addClass("show");
                        $("#desktopLocationSelectorAuto").removeClass("show");
                    }
                },
                error: function (xhr, status, error) {
                    $("#desktopLocationSelector").addClass("show");
                    $("#desktopLocationSelectorAuto").removeClass("show");
                }
            });
        }
        else {
            $("#desktopLocationSelector").addClass("show");
            $("#desktopLocationSelectorAuto").removeClass("show");
        }
    });
    $(".close-selector").on("click", function () {
        $(this).parent().parent().parent().parent().removeClass("show");
    });

    //Desktop Modal show - on click of State/Provinces
    $("#desktopLocationSelector .state-content .state-selector a, #desktopLocationSelectorAuto #manualLocationSelection .state-selector a").each(function () {
        $(this).on("click", function (e) {
            var linkUrl = $(this).attr("href");
            var stateTitle = $(this).attr("data-location-title");
            var cookieTitle = $(this).attr("data-cookie-title");
            var stateMiniTitle = $(this).data("location");
            e.preventDefault();
            $(".close-selector").click();
            $(".change-location-modal").modal("show");
            if (window.location.href.includes("privacy-policy")) {
                $(".new-location-btn").attr("href", "#");
            }
            else {
                $(".new-location-btn").attr("href", linkUrl);
            }

            $(".new-location-block").on("click", function () {
                document.cookie = "cookieTitle=" + cookieTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                document.cookie = "stateTitle=" + stateTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                document.cookie = "stateMiniTitle=" + stateMiniTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                updateContent(stateTitle, stateMiniTitle);
                if (window.location.href.includes("privacy-policy")) {
                    location.reload(window.location.href);
                }
            });

        });
    });
    $("#locationSelectionMain .desktop-location-selection .location-images-block a").each(function () {
        $(this).on("click", function () {
            var linkUrl = $(this).attr("href");
            var stateTitle = $(this).attr("data-location-title");
            var cookieTitle = $(this).attr("data-cookie-title");
            var stateMiniTitle = $(this).data("location");

            //Cookie value
            document.cookie = "cookieTitle=" + cookieTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            document.cookie = "stateTitle=" + stateTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            document.cookie = "stateMiniTitle=" + stateMiniTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            updateContent(stateTitle, stateMiniTitle);
        });
    });

    //Language
    $("#selectalanguageDD").siblings(".dropdown-menu").find("a").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            var selectedLang = $(this).text();
            var selectedLink = $(this).attr("href");
            $("#selectalanguageDD > span:first").text(selectedLang);
            document.cookie = "selectedLanguage=" + selectedLang + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
        });
    });

    //Mobile Geolocation dropdown show-hide
    $("#geoLocationMobileBtn").on("click", function () {
        if ($geoip === "true") {
            $.ajax({
                url: '/api/sitecore/GeoIP/GetLocationByIP',
                method: 'GET',
                success: function (data) {
                    $('#geoip-location').val(data.Region);
                    var fetchedregion = $('#geoip-location').val();
                    if (locationminititleData.includes(fetchedregion)) {
                        locationData.forEach(state => {
                            if (state.locationminititle === fetchedregion) {
                                $("#mobileLocationSelectorAuto .detected-location").text(state.locationtitle);
                                $("#mobileLocationSelectorAuto #newLocationSite").text(state.locationtitle);
                                $("#mobileLocationSelectorAuto .mobile-currently-selected .mobSelectedLocation").text(state.locationtitle);
                                $(".auto-detected-region-btn").attr("href", state.locationhref);

                                $(".auto-detected-region-btn").on("click", function () {
                                    document.cookie = "stateTitle=" + state.locationtitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                    document.cookie = "stateMiniTitle=" + state.locationminititle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                    updateContent(state.locationtitle, state.locationminititle);
                                });
                            }
                        });

                        $("#mobileLocationSelectorAuto .selected-state a").each(function () {
                            var state = $(this).data('location');
                            if (state === fetchedregion) {
                                $(this).removeClass('hide');
                            } else {
                                $(this).addClass('hide');
                            }
                        });

                        $("#mobManualDetection select option").each(function () {
                            var $value = $(this).val();
                            if ($value === fetchedregion) {
                                $(this).addClass('hide');
                            } else {
                                $(this).removeClass('hide');
                            }
                        });

                        $("#mobManualDetection select").on("change", function () {
                            $("#mobManualDetection select option").each(function () {
                                var stateMiniTitle = $(this).val();
                                var stateTitle = $(this).text();
                                var cookieTitle = $(this).attr("data-cookie-title");
                                var $link = $(this).attr("data-region-link");
                                if ($(this).is(":selected")) {
                                    var sanitizedLink = sanitizeURL($link);
                                    if (sanitizedLink) {
                                        window.location.href = sanitizedLink;
                                        document.cookie = "cookieTitle=" + cookieTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                        document.cookie = "stateTitle=" + stateTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                        document.cookie = "stateMiniTitle=" + stateMiniTitle + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                                        updateContent(stateTitle, stateMiniTitle);
                                    } else {
                                        console.error("Invalid link, navigation aborted.");
                                    }
                                }
                            });
                        });

                        $("#mobileLocationSelector").removeClass("show");
                        $("#mobileLocationSelectorAuto").addClass("show");
                        $("#mobileLocationSelectorAuto").parent("body").css("position", "fixed");
                        $("#mobileLocationSelectorAuto").parent("body").css("height", "100%");
                    }
                    else {
                        $("#mobileLocationSelectorAuto").removeClass("show");
                        $("#mobileLocationSelector").addClass("show");
                        $("#mobileLocationSelector").parent("body").css("position", "fixed");
                        $("#mobileLocationSelector").parent("body").css("height", "100%");
                        alreadySelectedRegionBlock();
                    }
                },
                error: function (xhr, status, error) {
                    $("#mobileLocationSelectorAuto").removeClass("show");
                    $("#mobileLocationSelector").addClass("show");
                    $("#mobileLocationSelector").parent("body").css("position", "fixed");
                    $("#mobileLocationSelector").parent("body").css("height", "100%");
                    alreadySelectedRegionBlock();
                }
            });
        }
        else {
            $("#mobileLocationSelectorAuto").removeClass("show");
            $("#mobileLocationSelector").addClass("show");
            $("#mobileLocationSelector").parent("body").css("position", "fixed");
            $("#mobileLocationSelector").parent("body").css("height", "100%");
            alreadySelectedRegionBlock();
        }
    });
    $(".mob-close-selector, .stay-on-page-block").on("click", function () {
        $("#mobileLocationSelector, #mobileLocationSelectorAuto").removeClass("show");
        $("#mobileLocationSelector, #mobileLocationSelectorAuto").parent("body").css("position", "unset");
        $("#mobileLocationSelector, #mobileLocationSelectorAuto").parent("body").css("height", "unset");
    });

    //Mobile Geolocation - setting the values
    $("#mobileLocationSelector .state-selector .location-form .mobile-state").on("change", function () {
        var selectedState = $(this).find("option:selected").val();
        var selectedValue = $(this).find("option:selected").text();
        $("#mobileLocationSelector .selected-state a").each(function () {
            var state = $(this).data('location');
            if (state === selectedState) {
                $(this).removeClass('hide');
                var redirectLink = $(this).attr('data-link-url');
                $("#mobileLocationSelector .go-to-page-block").attr('href', redirectLink);
            } else {
                $(this).addClass('hide');
            }
        });
        $("#mobileLocationSelector .go-to-page-block").removeClass("hide");
        $("#mobileLocationSelector .stay-on-page-block").addClass("hide");
        $("#mobileLocationSelector .mobile-currently-selected.hide").removeClass("hide");
        $("#mobileLocationSelector .mobSelectedLocation").text($(this).find("option:selected").text());
        $("#mobileLocationSelector #newLocationSite").text($(this).find("option:selected").text());

        //Go to state's site
        $("#mobileLocationSelector .mobile-location-submit").on("click", function () {
            document.cookie = "cookieTitle=" + selectedValue + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            document.cookie = "stateTitle=" + selectedValue + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            document.cookie = "stateMiniTitle=" + selectedState + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
            updateContent(selectedValue, selectedState);
        });
    });

    //Select all the <a> elements within the desktopLocationList
    if ($('.geoip-detection .desktopLocationList a').length) {
        $('.geoip-detection .desktopLocationList a').each(function () {
            const $this = $(this);
            const locationtitle = $this.attr('data-location-title');
            const locationarray = locationtitle.toLowerCase();
            const locationminititle = $this.data('location');
            const locationhref = $this.attr('href');

            const selectedLocationObject = {
                locationtitle,
                locationminititle,
                locationhref
            };

            locationData.push(selectedLocationObject);
            locationminititleData.push(locationminititle);
            locationtitleData.push(locationarray);
        });
    }

    //If Language is in Cookie
    if (selectedLang) {
        $("#selectalanguageDD > span:first").text(selectedLang);
    }

    //If region is in Cookie
    if (stateTitle && stateMiniTitle) {
        updateContent(stateTitle, stateMiniTitle);
        $(".my-selected-location").text(stateTitle);

        if (pageLocation !== "" && !pageLocation.includes(cookieState)) {
            if ($.inArray(pageLocation, locationtitleData) !== -1) {
                $(".welcome-back-modal").modal("show");
                $(".my-current-location").text(pageLocation);
            }
            else {
                $(".welcome-back-modal").modal("hide");
                $(".my-current-location").text("");
            }
        }

        let currentUrl = window.location.href;
        if (currentUrl.includes("/Search#q") && !currentUrl.includes("pagecategory")) {
            let newUrl = currentUrl + "&f:pagecategory=[" + cookieState + "]";
            window.location.href = newUrl;
        }

        if (trimmedcurrentUrl == hostname) {
            $(".welcome-back-modal").modal("show");
            $(".current-location-btn").text($(".my-current-page").text());
            $(".my-current-location").text(pageLocation);
        }

    }
    else {
        if (window.location.href.includes("privacy-policy")) {
            if ($geoip === "true") {
                $("#desktopLocationSelectorAuto").addClass("show");
            }
            else {
                $("#desktopLocationSelector").addClass("show");
            }
        }
    }

    //Get cookie value
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    //Update content for both desktop and mobile
    function updateContent(desktopValue, mobileValue) {
        updateDesktopContent(desktopValue);
        updateMobileContent(mobileValue);
    }

    //Cookie value for desktop location
    function updateDesktopContent(value) {
        $('#geolocationBtn span').text(value);
    }

    //Cookie value for mobile location
    function updateMobileContent(value) {
        $('#mobile-location-btn .my-state').text(value);

        $('#mobile-location-btn')
            .attr('aria-label', value + ' location selector');

        $('#mobile-location-btn .my-state').addClass("state-selected");

        $(".my-state.state-selected").parent("button").css("border-bottom", "5px solid #FFB81C");
        $(".my-state.state-selected").parent("button").css("padding-bottom", "3px");
        $(".my-state.state-selected").parent("button").css("margin-bottom", "-5px");
    }

    //Function when user has already selected region earlier in mobile
    function alreadySelectedRegionBlock() {
        var mobBtnVal = $("#geoLocationMobileBtn").find(".my-state.state-selected").text();
        if (mobBtnVal !== '') {
            $("#mobileLocationSelector .mobile-state").val(mobBtnVal);
            var btnValue = $("#mobileLocationSelector .mobile-state").find("option:selected").text();
            $("#mobileLocationSelector #newLocationSite").text(btnValue);

            $("#mobileLocationSelector .selected-state a").each(function () {
                var state = $(this).data('location');
                if (state === mobBtnVal) {
                    $(this).removeClass('hide');
                    var redirectLink = $(this).attr('href');
                    $(".go-to-page-block").attr('href', redirectLink);
                } else {
                    $(this).addClass('hide');
                }
            });
            $("#mobileLocationSelector .mobile-currently-selected.hide").removeClass("hide");
            $("#mobileLocationSelector .mobSelectedLocation").text(btnValue);
            $("#mobileLocationSelector #currentLocationSite").text(btnValue);
            $("#mobileLocationSelector .go-to-page-block").addClass("hide");
            $("#mobileLocationSelector .stay-on-page-block").removeClass("hide");
        }
    }

    //Manual Location Selection Block styling
    function manualLocationDetection() {
        var $first = $('#manualLocationSelection .desktop-location-selection-new a[data-country="USA"]:not(.hide):first');
        var $last = $('#manualLocationSelection .desktop-location-selection-new a[data-country="USA"]:not(.hide):last');
        if ($('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]').hasClass('hide')) {
            if ($(window).width() > 1399) {
                $first.css('margin-left', '88px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-right', '35px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '35px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '0');
            }
            else if ($(window).width() > 1199 && $(window).width() < 1400) {
                $first.css('margin-left', '30px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-right', '10px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '10px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '0');
            }
            else if ($(window).width() > 991 && $(window).width() < 1200) {
                $first.css('margin-left', '52px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', '55px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-right', '30px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', 'unset');
            }
            else if ($(window).width() > 767 && $(window).width() < 966) {
                $first.css('margin-left', '25px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', '372px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '23px');
            }
            else if ($(window).width() > 965 && $(window).width() < 992) {
                $first.css('margin-left', '25px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', '392px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(1)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '32px');
            }
        }
        if ($('#manualLocationSelection .desktop-location-selection-new .state[data-country="Canada"]').hasClass('hide')) {
            if ($(window).width() > 1399) {
                $first.css('margin-left', '88px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '35px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '35px');
            }
            else if ($(window).width() > 1199 && $(window).width() < 1400) {
                $first.css('margin-left', '30px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '10px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '10px');
            }
            else if ($(window).width() > 991 && $(window).width() < 1200) {
                $first.css('margin-left', '52px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '30px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', '55px');
            }
            else if ($(window).width() > 767 && $(window).width() < 966) {
                $first.css('margin-left', '25px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', '27px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '23px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
            }
            else if ($(window).width() > 965 && $(window).width() < 992) {
                $first.css('margin-left', '25px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-right', '0');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-left', '27px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-right', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(3)').css('margin-right', '32px');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(4)').css('margin-left', 'unset');
                $('#manualLocationSelection .desktop-location-selection-new .state[data-country="USA"]:not(.hide):eq(2)').css('margin-left', 'unset');
            }
        }
    }

    //Check whether user has geoip screen and choosing manual location
    if ($("#manualLocationSelection").length) {
        manualLocationDetection();
        $('#manualLocationSelection .desktop-location-selection-new a[data-country="USA"]:not(.hide):last').css("margin-right", "0");
    }

    //Hide Change Location Modal in Mobile
    $(window).on('resize', function () {
        var win = $(this); //this = window
        if (win.width() <= 767) {
            if ($(".change-location-modal").is(":visible")) {
                $(".current-location-btn").click();
            }
        }
        if ($("#manualLocationSelection").length && $("#manualLocationSelection").is(":visible")) {
            manualLocationDetection();
        }
    });

    //Location Selection Mobile 
    $(".location-selection-dropdown").on("change", function () {
        var value = $(this).val();
        var title = $(this).find("option:selected").val();
        var linkToRedirect = $(this).find("option:selected").attr("data-link-ref");
        $(".location-selection-dropdown").val(value);
        $(".mobile-location-selection a").removeClass("hide");
        $(".mobile-location-selection a").attr("href", linkToRedirect);
        $("#selectedStateProvince").text(title);

        //Dropdown and cookie setting
        $(".location-selection-dropdown option").each(function () {
            var $value = $(this).attr("data-mini-value");
            var $text = $(this).text();
            if ($(this).is(":selected")) {
                $(".mobile-location-selection a").on("click", function () {
                    document.cookie = "cookieTitle=" + $text + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                    document.cookie = "stateTitle=" + $text + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                    document.cookie = "stateMiniTitle=" + $value + "; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
                    updateContent($text, $value);
                });
            }
        });
    });

    //Mobile Home page Location selection condition
    $(".mobile-location-selection a").on("click", function () {
        $(".location-selection-dropdown").val('');
    });

    //Welcome back popup continue button event ajax
    $("#welcomeBackBtn").on("click", function () {
        if (cookieState !== qcTitle) {
            $.ajax({
                url: '/api/sitecore/Navigation/GetPageByCookieLocation',
                method: 'GET',
                data: {
                    cookieLocation: cookieTitle,
                    currentPageTitle: currentPageTitle
                },
                success: function (response) {
                    $.ajax({
                        url: response.redirectToUrl,
                        type: 'GET',
                        success: function (data, textStatus, xhr) {
                            window.location.href = response.redirectToUrl;
                        },
                        error: function (xhr, textStatus, errorThrown) {
                            window.location.href = "/";
                        }
                    });
                },
                error: function (xhr, status, error) {
                    window.location.href = "/";
                }
            });
        }
        else {
            window.location.href = qcHref;
        }
    });
});

},{}],11:[function(require,module,exports){
"use strict";
//var dublicateData;
window.selectedParent = "";
window.selectedChild = "";
var onhoverElement = "";
$(document).ready(function () {

    //$('.dropdown-submenu a.test').click(function (e) {
    //    $(this).next('ul').toggle();
    //    e.stopPropagation();
    //    e.preventDefault();
    //});
    if ($('.header-primary.container .submenu.stickyHeaderBar').length) {
        $('.wrap-header .breadcrumb').addClass('sticky-breadcrumb')
    }
    if (window.innerWidth >= 770 && $('.hdnIsDynamic').length && ($('#hdnIsDynamic')[0].defaultValue != 'True' || $('#hdnIsDynamic')[0].defaultValue == null || $('#hdnIsDynamic')[0].defaultValue == '')) {
        $('#subMenu_sticky').show();
        $('#subMenu_sticky').addClass('stickyHeaderBar');
    }
});
//function for font Size. Add the sitecore value in place of "large" && "x-small"

var submenu = $('[id^="submenu"]').css('display', 'none');
//providing quick fix , working on its compact function
window.multiplier = 1;
function changeMultiplier(isScale) {

    if (window.multiplier == 2) {
        $('.fontBig').addClass('disable');
    }
    if (isScale && multiplier < 2) {
        $('.fontBig').removeClass('disable');
        multiplier += 0.25;
    }
    if (!isScale && multiplier > 1) {
        $('.fontSmall').removeClass('disable');
        multiplier -= 0.25;
    } else {
        $('.fontSmall').addClass('disable');
    }
}
window.fontBig = function () {
    changeMultiplier(true);
    $('.fontSmall').removeClass('disable');
    $('body').addClass('autoWidth');
    $('.header-sec').addClass('width-max-content');
    if (window.multiplier == 2) {
        $('.fontBig').addClass('disable');
    }
    document.body.style.zoom = multiplier;
}

window.fontSmall = function () {
    changeMultiplier(false);
    document.body.style.zoom = multiplier;
    if (window.multiplier == 1) {
        $('.fontSmall').addClass('disable');
        $('body').removeClass('autoWidth');
        $('.header-sec').removeClass('width-max-content');
    }

}

// hovering IN top level menu items "a" tags, like Residential, Business and Industrial.
var navbardrop = $('[id^="navbardrop"]');
var index;
for (var i = 0; i < navbardrop.length; i++) {
    $(navbardrop[i]).hover(function (e) {
        onhoverElement = e.currentTarget.id;  // onhoverElement will be like navbardrop_1 or navbardrop_2
        index = e.currentTarget.id[e.currentTarget.id.length - 1];
        var submenu = $('[id^="submenu"]');

        for (var navbar = 0; navbar < navbardrop.length; navbar++) {
            $(navbardrop[navbar]).find('.fa.fa-sort-desc').css('display', 'none');
        }
        if (window.innerWidth >= 770 && ($('#hdnIsDynamic')[0].defaultValue != 'True' || $('#hdnIsDynamic')[0].defaultValue == null || $('#hdnIsDynamic')[0].defaultValue == '')) {
            $(e.currentTarget).find('.fa.fa-sort-desc').css('display', 'none');
        }
        else {
            $(e.currentTarget).parent().find('.current-root').css('display', 'none');
            $(e.currentTarget).find('.fa.fa-sort-desc').css('display', 'block');
        }
        for (var j = 0; j < submenu.length; j++) {
            if (index == j + 1) {
                $(submenu[j]).css("display", "block");
            } else {
                $(submenu[j]).css("display", "none");
            }
        }
    });
    $(navbardrop[i]).on('keydown', function (e) {

        if (e.key === 'ArrowDown' || e.key === ' ') {

            e.preventDefault();

            const $currentMenu = $(e.currentTarget)
                .closest('.nav-item')
                .find('.dropdown-menu');

            $('.dropdown-menu').css({
                'visibility': 'hidden',
                'opacity': 0
            });

            $currentMenu.css({
                'visibility': 'visible',
                'opacity': 1,
                'transform': 'rotateX(0deg)',
                'background': '#fff',
                'box-shadow': '0 10px 50px rgba(0, 0, 0, .17)'
            });

            $('.nav-link.dropdown-toggle')
                .attr('aria-expanded', 'false');

            $(e.currentTarget)
                .attr('aria-expanded', 'true');

            $currentMenu
                .find('a:visible')
                .first()
                .focus();
        }
    });
    $('.nav-item').on('focusout', function () {

        var currentItem = this;

        setTimeout(function () {

            if (!$(currentItem).find(':focus').length) {

                $(currentItem)
                    .find('.dropdown-menu')
                    .removeAttr('style');

            }

        }, 10);
    });
}

// hover OUT of Div that contains top level menu items, close second level menu and megamenu
$('#navbarNav').hover(function (e) { }, function (e) {
    onhoverElement = ""
    closeMenus()
});

// hover OUT for div that contains all levels of menu, , close second level menu and megamenu
$('.header-primary').hover(function (e) { }, function (e) {
    onhoverElement = ""
    closeMenus()
});

//logic for header dropdown highlight active
$('#signinDD, #selectalanguageDD').on('click', function () {
    $(this).toggleClass('active');
});
$('#signinDD, #selectalanguageDD').on('blur', function () {
    $(this).removeClass('active');

});//end

//hides secondary level menu and mega menu
function closeMenus() {
    setTimeout(function () {
        if (onhoverElement == "") {
            for (var navbar = 0; navbar < navbardrop.length; navbar++) {
                $(navbardrop[navbar]).find('.fa.fa-sort-desc').css('display', 'none');
                $(navbardrop[navbar]).parent().find('.current-root').css('display', 'block');
            }
            var submenu = $('[id^="submenu"]');
            for (var j = 0; j < submenu.length; j++) {
                $(submenu[j]).css("display", "none");
            }
            submenu = null;
            var mega_menu = $('[id^="mega-menu"]');
            for (var p = 0; p < mega_menu.length; p++) {
                $(mega_menu[p]).css("display", "none");
            }
            mega_menu = null;
        }
    }, 5000);
}

$("#navbarNav a").on("keydown keypress", function (e) {
    var currentElementId = e.currentTarget.id;
    currentElementId = currentElementId[currentElementId.length - 1];
    currentElementId = parseInt(currentElementId);
    var menuList = $(e.currentTarget).parents("ul").children();
    if (e.keyCode == 37) {
        if (currentElementId == 1)
            currentElementId = 2;
        $(menuList[currentElementId - 2]).find("a").focus();
        e.preventDefault();
    }
    if (e.keyCode == 38) {
        e.preventDefault();
    }
    if (e.keyCode == 39) {
        $(menuList[currentElementId]).find("a").focus();
        e.preventDefault();
    }
    if (e.keyCode == 40) {
        e.preventDefault();
        index = e.currentTarget.id[e.currentTarget.id.length - 1];
        var submenu = $('[id^="submenu"]');
        for (var navbar = 0; navbar < navbardrop.length; navbar++) {
            $(navbardrop[navbar]).find('.fa.fa-sort-desc').css('display', 'none');
        }
        if (window.innerWidth >= 770 && ($('#hdnIsDynamic')[0].defaultValue != 'True' || $('#hdnIsDynamic')[0].defaultValue == null || $('#hdnIsDynamic')[0].defaultValue == '')) {
            $(e.currentTarget).find('.fa.fa-sort-desc').css('display', 'none');
        }
        else {
            $(e.currentTarget).find('.fa.fa-sort-desc').css('display', 'block');
        }
        for (var j = 0; j < submenu.length; j++) {
            if (index == j + 1) {
                $(submenu[j]).css("display", "block");
                $("#" + submenu[j].id + " .submenu_nav li a").first().focus();
            } else {
                $(submenu[j]).css("display", "none");
            }
        }
    }
    menuList = null;
});
function keydown(currentSubmenu) {
    return function (e) {
        var element = $(this)
        if (e.keyCode == 37) {
            e.preventDefault();
            if ($("#" + currentSubmenu + " .submenu_nav li:first-child .dropdown-toggle").id == $(this).id) {
                $("#navbardrop_" + currentSubmenu[currentSubmenu.length - 1]).focus();
            }
        }
        if (e.keyCode == 38) {
            e.preventDefault();
            for (var navbar = 0; navbar < navbardrop.length; navbar++) {
                $(navbardrop[navbar]).find('.fa.fa-sort-desc').css('display', 'none');
            }
            var submenu = $('[id^="submenu"]');
            for (var j = 0; j < submenu.length; j++) {
                $(submenu[j]).css("display", "none");
            }
            submenu = null;
            $("#navbardrop_" + currentSubmenu[currentSubmenu.length - 1]).focus();
        }
        if (e.keyCode == 39) {
            e.preventDefault();
            if ($("#" + currentSubmenu + " .submenu_nav li:last-child .dropdown-toggle").id == $(this).id) {
                $("#navbardrop_" + currentSubmenu[currentSubmenu.length - 1]).focus();
            }
        }
        if (e.keyCode == 40) {
            $(".dropdown-toggle").mouseleave();
            element.mouseenter();
            element.siblings("div:eq(0)").find("a:eq(0)").focus();
            e.preventDefault();
        }
    }
}

// for each DIV containing second level navigation - when hovering IN, set onhoverElement to element id,
// when hovering Out set it to "" and call closeMenus() - which
// hides second level navigation and megamenu with delay of 8sec 
var submenu = $('[id^="submenu"]');  // div(s) that contain second level menus for each top level menu item
for (var j = 0; j < submenu.length; j++) {
    $(submenu[j]).hover(function (e) {
        onhoverElement = e.currentTarget.id;
    }, function () {
        onhoverElement = ""
        closeMenus()
    });
    var currentSubmenu = submenu[j].id;
    $("#" + currentSubmenu + " .submenu_nav li .dropdown-toggle").on("keydown keypress", keydown(currentSubmenu));
}
submenu = null;


$(".megamenu a").on("keydown keypress", function (e) {
    var element = $(this);
    var child = element[0];
    var parent = element.closest(".megamenu").find("a");
    var index = Array.prototype.indexOf.call(parent, child);
    if (e.keyCode == 37) {
        element.closest(".megamenu-li").find(".dropdown-toggle").focus().parent().prev().eq(0).find(".dropdown-toggle").focus().mouseenter();
    } else if (e.keyCode == 38) {
        if (index == 0) {
            element.closest(".megamenu").siblings(".dropdown-toggle").focus();
        } else {
            parent[index - 1].focus();
        }
    } else if (e.keyCode == 39) {
        element.closest(".megamenu-li").find(".dropdown-toggle").focus().parent().next().eq(0).find(".dropdown-toggle").focus().mouseenter();
    } else if (e.keyCode == 40) {
        if (index + 1 < parent.length) {
            parent[index + 1].focus();
        }
    }
});

// hover IN for second level menu
var dropdown = $('[id^="dropdown"]'); // this is second level menu items "a" tags, like New Customers, Rebates and Energy Concervation.
for (var k = 0; k < dropdown.length; k++) {
    $(dropdown[k]).hover(function (e) {
        var megaMenuId = e.currentTarget.id.replace("dropdown", "mega-menu");
        var mega_menu = $('[id^="mega-menu"]');

        setTimeout(function () {
            if (hoverOverMegaMenuId == null) {  // trigger this logic only there is no mega menu opened
                for (var p = 0; p < mega_menu.length; p++) {
                    if (mega_menu[p].id == megaMenuId) {
                        $(mega_menu[p]).css("display", "block"); // display mega menu for the item we are hovering over
                    } else {
                        $(mega_menu[p]).css("display", "none"); // hide all other mega menus
                    }
                }
            }
        }, 500);


    });

}


// hover in and out for megamenu
var hoverOverMegaMenuId = null;
$('[id^="mega-menu"]').hover(function (e) {
    hoverOverMegaMenuId = e.currentTarget.id;
}, function (e) {
    // close mega menu when hoverign out
    $('#' + e.currentTarget.id).css("display", "none");
    hoverOverMegaMenuId = null;
});

$(".submenu a.nav-link.dropdown-toggle").focusin(function (e) {
    $(this).siblings('[id^="mega-menu"]').css('display', 'none')
});//removed click megamenu


if (window.innerWidth <= 769) {
    $('.fontSmall').css("pointer-events: none");
    $('#aboutEmbridgeID').remove();
    $('#careerID').remove();
    $('#ID').remove();
    $('#hovernav').remove();
    $('#navbardrop').remove();
    $('#menuButtonID').show();
    $('#mainDiv').addClass('hide');
    //$(document).ready(function () {
    //    $('.dropdown-submenu a.test').click(function (e) {
    //        $(this).next('ul').toggle();
    //        e.stopPropagation();
    //        e.preventDefault();
    //    });
    //});
}

var parentBackward = false;
var parentDiv = $('[id^="parentDiv"]');

for (var i = 0; i < parentDiv.length; i++) {
    var parentDiv_ID = parentDiv[i].id;
    $('#' + parentDiv_ID).click(function (e) {
        if (parentBackward === false) {
            parentBackward = true;
            $('#' + e.currentTarget.id).siblings().css('display', 'none');
            $('#' + e.currentTarget.id + " .fa").first().removeClass('fa-caret-right');
            $('#' + e.currentTarget.id + " .fa").first().addClass('fa-caret-left');
            var activeMenu = $('#' + e.currentTarget.id + " .fa").first().parent();
            activeMenu.addClass('menu-backward-navigator');
            activeMenu.siblings().find('.menu-navigator').addClass('menu-sibling-navigator')
            activeMenu = null;
            window.selectedParent = "#" + e.currentTarget.id;
            var parentOfChildID = $('[id^="parentOfChild"]');

            for (var p = 0; p < parentOfChildID.length; p++) {
                var parentOfChild_ID = parentOfChildID[p].id;
                $('#' + e.currentTarget.id).find('#' + parentOfChild_ID).css('display', 'block'); //$('#' + e.currentTarget.id).find('.caret').addClass('fa-caret-right ');
                //$('#' + e.currentTarget.id).find('.caret').addClass('fa-caret-left');
            }

            var subChildID = $('[id^="subChild"]');

            for (var p = 0; p < subChildID.length; p++) {
                var subChild_ID = subChildID[p].id;
                $('#' + e.currentTarget.id).find('#' + subChild_ID).css('display', 'none'); //$('#' + e.currentTarget.id).find('.caret').addClass('fa-caret-right ');
                //$('#' + e.currentTarget.id).find('.caret').addClass('fa-caret-left');
            } //parentBackward = false;

        }
        else {
            window.selectedParent = "";
            if (window.selectedChild !== "") {
                $(window.selectedChild).trigger("click");
            }
            parentBackward = false;
            var parentOfChildID = $('[id^="parentOfChild"]');
            //$('#mainDiv').html(duplicateData);
            //$('#parentDiv_2').click(function () {
            //    alert("hello!!");
            //})
            for (var p = 0; p < parentOfChildID.length; p++) {
                var parentOfChild_ID = parentOfChildID[p].id;
                $('#' + e.currentTarget.id).find('#' + parentOfChild_ID).css('display', 'none');
                $('#' + e.currentTarget.id + " .fa").first().addClass('fa-caret-right');
                $('#' + e.currentTarget.id + " .fa").first().removeClass('fa-caret-left');
                var activeMenu = $('#' + e.currentTarget.id + " .fa").first().parent();
                activeMenu.removeClass('menu-backward-navigator');
                activeMenu.siblings().find('.menu-navigator').removeClass('menu-sibling-navigator');
                activeMenu = null;
            }

            var subChildID = $('[id^="subChild"]');

            for (var p = 0; p < subChildID.length; p++) {
                var subChild_ID = subChildID[p].id;
                $('#' + e.currentTarget.id).find('#' + subChild_ID).css({ 'display': 'block', 'padding-left': '0px' });
            }

            $('#' + e.currentTarget.id).siblings().css('display', 'block');
            parentOfChildBackward = false;
        }

        event.stopPropagation();
    });
}
$('.dropDownText').click(function (e) {
    e.stopPropagation();
});
var parentOfChildBackward = false;
var childID = $('[id^="child"]');

for (var p = 0; p < childID.length; p++) {
    var child_ID = childID[p].id;
    $('#' + child_ID).click(function (event) {
        if (parentOfChildBackward === false) {
            window.selectedChild = "#" + event.currentTarget.id;
            $('#' + event.currentTarget.id).siblings().css('display', 'none');
            $('#' + event.currentTarget.id).find('ul').css('display', 'block');
            parentOfChildBackward = true;
            $('#' + event.currentTarget.id + " .fa").first().removeClass('fa-caret-right');
            $('#' + event.currentTarget.id + " .fa").first().addClass('fa-caret-left');
            var activeMenu = $('#' + event.currentTarget.id + " .fa").first().parent();
            activeMenu.addClass('menu-backward-navigator');
            if (activeMenu.hasClass('menu-sibling-navigator')) {
                activeMenu.removeClass('menu-sibling-navigator')
            }
            activeMenu = $('#' + event.currentTarget.id).parent().siblings('.menu-backward-navigator');
            activeMenu.addClass('border-bottom-black');
            activeMenu = null;
        } else {
            window.selectedChild = "";
            $('#' + event.currentTarget.id).siblings().css('display', 'block');
            $('#' + event.currentTarget.id).find('ul').css('display', 'none');
            parentOfChildBackward = false;
            $('#' + event.currentTarget.id + " .fa").first().addClass('fa-caret-right');
            $('#' + event.currentTarget.id + " .fa").first().removeClass('fa-caret-left');
            var activeMenu = $('#' + event.currentTarget.id + " .fa").first().parent();
            activeMenu.removeClass('menu-backward-navigator');
            if (!activeMenu.hasClass('menu-sibling-navigator')) {
                activeMenu.addClass('menu-sibling-navigator')
            }
            activeMenu = $('#' + event.currentTarget.id).parent().siblings('.menu-backward-navigator');
            activeMenu.removeClass('border-bottom-black');
            activeMenu = null;
        }
        event.stopPropagation();
    });
}
window.menuClick = function () {

    $("#mainDiv").trigger('reset');
    $("#mainDiv").removeClass('hide')
    $('.navbar-brand .padding0').css({
        'border': '2px solid black',
        'height': '70px'
    });

    var childOfchild = $('[id^="parentOfChild"]');

    for (var i = 0; i < childOfchild.length; i++) {
        var parentOfChild_ID = childOfchild[i].id;
        $('#' + parentOfChild_ID).hide();
    }

    $('#menuButtonID').hide();
    $('#crossButtonID').removeClass('hide');
    $('.header-sec').addClass('hide-in-mobile');
    $('#menuButtonID').addClass('borderLeft');



    if ($('.firstCaret').length) {
        $('.firstCaret').show();
    }

};

window.crossButtonClick = function () {
    if (window.selectedChild !== "") {
        $(window.selectedChild).trigger("click");
    }

    if (window.selectedParent !== "") {
        $(window.selectedParent).trigger("click");
    }

    $('.navbar-brand .padding0').removeClass('imageSize');
    $('#mainDiv').addClass('hide')
    $('#menuButtonID').show();
    $('#crossButtonID').addClass('hide');
    $('.header-sec').removeClass('hide-in-mobile');
};

if ($('.firstCaret').length) {
    $('.firstCaret').show();
}

function submitSearch($container) {
    var $searchQuery = $(".search-query", $container);
    var q = encodeURIComponent($searchQuery.val());
    var link = $searchQuery.data("src");
    if (q) {
        link += "#q=" + q;
    }

    window.location.href = link;
}

$(".search-link-new").on('click', function (e) {
    e.preventDefault();
    var $searchButton = $(this);
    var $container = $searchButton.parent();
    submitSearch($container);
})

$('.search-query').on('keyup', function (e) {
    if (event.key === "Enter") {
        event.preventDefault();
        var $searchInput = $(this);
        var $container = $searchInput.parent();
        submitSearch($container);
    }
})
},{}],12:[function(require,module,exports){
window.setupPostalCodeValidation = function (config) {
    const $input = $(config.inputSelector);
    const $target = $(config.targetSelector);
    const $hiddenHtml = $(config.hiddenHtmlSelector);
    const $addressInput = config.addressSelector ? $(config.addressSelector) : null;

    const rawCodes = $(config.dataSourceSelector).attr('data-valid-irp-postal-codes');

    $target.hide();

    var codeArray = JSON.parse(rawCodes);

    var valid3DigitCodes = [];
    var valid6DigitCodes = [];

    for (var i = 0; i < codeArray.length; i++) {
        var originalCode = codeArray[i];
        var cleanedCode = originalCode.replace(/\s+/g, '').trim().toLowerCase();

        if (cleanedCode.length === 3) {
            valid3DigitCodes.push(cleanedCode);
        } else if (cleanedCode.length === 6) {
            valid6DigitCodes.push(cleanedCode);
        }
    }

    function checkPostalCode() {
        const inputVal = $input.val().trim().replace(/\s+/g, '').toLowerCase();

        if (inputVal.length >= 6) {
            const first3 = inputVal.substring(0, 3);
            const first6 = inputVal.substring(0, 6);

            const isValid =
                (inputVal.length >= 6 && valid6DigitCodes.includes(first6)) ||
                valid3DigitCodes.includes(first3);

            if (isValid) {
                if ($hiddenHtml) {
                    $target.html($hiddenHtml.html()).show();
                } else {
                    $target.show();
                }
                if (($("#SarniaSavesModal").length && $(".wholesHomeRadio").eq(1).find(":radio:checked").parent().text() === 'Natural gas supplied by Enbridge Gas' && $(".wholesHomeRadio").eq(2).find(":radio:checked").parent().text() === "No")
                    || ($("#SarniaSavesModal").length && $(".attic-heat-home").eq(4).find(":radio:checked").parent().text() === 'Natural gas supplied by Enbridge Gas' && $(".attic-heat-home").eq(5).find(":radio:checked").parent().text() === "No")) {
                    $("#SarniaSavesModal").modal('show');
                }
            } else {
                $target.hide();
                if ($("#SarniaSavesModal").length) {
                    $("#SarniaSavesModal").modal('hide');
                }
            }
        } else {
            $target.hide();
        }
    }

    $input.on('keyup change focus', checkPostalCode);

    if ($addressInput && $addressInput.length > 0) {

        $addressInput.on('input change keyup focus', checkPostalCode);

        $addressInput.on('input change keyup focus', function () {
            setTimeout(checkPostalCode, 300);
        });
    }

    checkPostalCode();
}
},{}],13:[function(require,module,exports){
if ($('#sticky-navigation-container').length) {
   
    window.onscroll = function () { myFunction() };

    var navbar = document.getElementById("navbarSticky");
    var sticky = $('#navbarSticky').offset().top;
   // var bottom = $('.footer-top').offset().top - $('#navbarSticky').outerHeight() ;
   
    var anchorClick = false;
    function myFunction() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("stickyHeader")
        } else {
            if (!anchorClick) {
                navbar.classList.remove("stickyHeader");
            }
        }
    }
    $(document).ready(function () {
        $(document).on("scroll", onScroll);

        //smoothscroll
        $('#navbarSticky a[href^="#"]').on('click', function (e) {
            anchorClick = true;
            navbar.classList.add("stickyHeader")
            e.preventDefault();
            $(document).off("scroll");
            $('#navbarSticky').find('a').each(function (e) { $(this).removeClass("active"); });
            $(this).addClass('active'); 
            var target = this.hash,
                menu = target;
            $target = $(target);
            $('html, body').animate({
                'scrollTop': $target.offset().top - $('#navbarSticky').outerHeight()
            }, 600, 'swing', function () {
                // window.location.hash = target;                   
                    $(document).on("scroll", onScroll);
                    anchorClick = false;
            });
            

        });
    });   


    window.onScroll = function (event) {
        var scrollPos = $(document).scrollTop();
       
        $('#navbarSticky').find('a').each(function () {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));            
            if (refElement.length) {
                if ((refElement.offset().top - $('#navbarSticky').outerHeight()) <= scrollPos && (refElement.offset().top - $('#navbarSticky').outerHeight()) + refElement.height() > scrollPos) {
                    $('#navbarSticky').find('a').each(function (e) { $(this).removeClass("active"); });
                    currLink.addClass("active");
                }

                else {
                    currLink.removeClass("active");
                }
            }
        });
    }

}

},{}],14:[function(require,module,exports){
$(document).ready(function () {
    if ($('.accordion-component').length > 0) {
        var hash = document.location.hash;
        if (hash) {
            $(hash).collapse("show");
            var Guid = $(hash).closest(".panel-collapse.collapse").attr("id");
            if (Guid) {
                var GuidVal = "#" + Guid;
                $(GuidVal).collapse("show");
            }
        }
        
    }
    
});
$(window).on('load', function () {
    $('.panel-collapse.collapse').on('show.bs.collapse', function () {
        var currentPanel = $(this).parents('.panel-group');
        if (currentPanel.length) {
            var noOfClasses = currentPanel.attr('class').split(/\s+/).length;
            var otherPanels = null;
            if (noOfClasses > 1) {
                otherPanels = currentPanel.siblings();
                $('.panel-collapse.collapse', otherPanels).collapse('hide');
            } else {
                otherPanels = currentPanel.parent().siblings();
                $('.panel-collapse.collapse', otherPanels).collapse('hide');
            }
            otherPanels = null;
            currentPanel = null;
        }
    });
});
},{}],15:[function(require,module,exports){
setTimeout(function () {
    $(document).ready(function () {

        $(function () {
            $('.notify-block').slideDown();
        });

        //Ontario Megamenu scroll for Tab/Desktop
        if ($("#fixedHeaderBlock").length) {
            if (window.matchMedia("(min-width: 992px)").matches) {
                stickyNavigation();
            }
            $(window).resize(function () {
                if ($(window).width() < 992) {
                    normalHeader();
                    $(window).scroll(function () {
                        normalHeader();
                    });
                }
                else {
                    stickyNavigation();
                }
            }).trigger('resize');
        }

        //Other State Megamenu scroll for Tab/Desktop
        if ($("#fixedMiniHeaderBlock").length) {
            if (window.matchMedia("(min-width: 992px)").matches) {
                stickyNavigation();
            }
            $(window).resize(function () {
                if ($(window).width() < 992) {
                    normalHeader();
                    $(window).scroll(function () {
                        normalHeader();
                    });
                }
                else {
                    stickyNavigation();
                }
            }).trigger('resize');
        }
    });
}, 2000);

function normalHeader() {
    $('.fix-header-block').css("position", "relative");
    $('.fix-header-block').css("top", "unset");
    $('.fix-header-block').css("z-index", "1");
    $('.fix-header-block').css("box-shadow", "none");
}

function newFixedHeader() {
    $('.fix-header-block').css("position", "fixed");
    $('.fix-header-block').css("top", "0");
    $('.fix-header-block').css("z-index", "1000");
    $('.fix-header-block').css("box-shadow", "0 .5rem 1rem rgba(0, 0, 0, .15)");
}

function stickyNavigation() {
    var alertBlock = 0, headerSection = 0, calculatedHeight = 0;

    if ($(".notify-block").length) {
        alertBlock = $(".notify-block").height();
    }
    if ($(".header-sec").length) {
        headerSection = $(".header-sec").height();
    }
    if ((!$(".header-sec").length || $(".header-sec").height() == 0) && (!$(".notify-block").length) || $(".notify-block").height() == 0) {
        calculatedHeight = 0;
    }

    calculatedHeight = alertBlock + headerSection;

    $(window).scroll(function () {
        if ($(window).scrollTop() > calculatedHeight) {
            newFixedHeader();
        } else {
            normalHeader();
        }
    });
}

$('.alert-close').click(function () {
    $(this).parent().parent().parent().parent().slideUp().empty();
    var cookieName = $(this).attr("id");

    $.ajax({
        'type': 'POST',
        'url': '/api/sitecore/Alert/SaveCookie',
        'data': {
            'cookie': cookieName,
            "__RequestVerificationToken": $("input[name=__RequestVerificationToken]").val()
        },// adding antiforgerytoken as part of RLSE0018904
        'success': function success(result, status, xhr) {
            //if (xhr.readyState === 4 && xhr.status === 200 && result.toLowerCase() == "true") {
            //    console.log('alert saved in cookie');
            //}
        }
    });
    stickyNavigation();
});
},{}],16:[function(require,module,exports){

$(document).ready(function () {
  
    if ($('#myCarousel_DSK').length) {
        if ($(".carousel-custom-control .carousel-indicators.cc_CI li").length > 1) {
            $(".carousel-custom-control .carousel-indicators.cc_CI li").first().addClass('active');
        } else {
            $(".carousel-custom-control").addClass('display-none');
        }
        window.carouselInterval = setInterval(checkFirstandLast, 500);
        function checkFirstandLast() {
            if ($(".carousel-indicators.cc_CI li").first().hasClass('active')) {
                $('#myCarousel_DSK .carousel-custom-control .prev_chev').addClass('display-none');
                $('#myCarousel_DSK .carousel-custom-control .left.carousel-control .sr-only').addClass('display-none');
            } else {
                $('#myCarousel_DSK .carousel-custom-control .prev_chev').removeClass('display-none');
                $('#myCarousel_DSK .carousel-custom-control .left.carousel-control .sr-only').removeClass('display-none');
            }
            if ($(".carousel-indicators.cc_CI li").last().hasClass('active')) {
                $('#myCarousel_DSK .carousel-custom-control .next_chev').addClass('display-none');
                $('#myCarousel_DSK .carousel-custom-control .right.carousel-control .sr-only').addClass('display-none');
            } else {
                $('#myCarousel_DSK .carousel-custom-control .next_chev').removeClass('display-none');
                $('#myCarousel_DSK .carousel-custom-control .right.carousel-control .sr-only').removeClass('display-none');
            }
        }

    }

})
//window.onunload=function () {
//    if ($('#myCarousel_DSK').length) {
//        clearInterval(window.carouselInterval);
//    }
//}
window.addEventListener("pagehide",function () {
        if ($('#myCarousel_DSK').length) {
            clearInterval(window.carouselInterval);
        }
});

window.showSlides = function  (n, no) {
    var i;
    var x = document.getElementsByClassName(slideId[no]);
    if (n > x.length) { slideIndex[no] = 1 }
    if (n < 1) { slideIndex[no] = x.length }
    for (i = 0; i < x.length; i++) {
        x[i].style.display = "none";
    }
    if (x[slideIndex[no] - 1] !== typeof (undefined) && x[slideIndex[no] - 1] !== "undefined" && x[slideIndex[no] - 1] !== undefined) {
        x[slideIndex[no] - 1].style.display = "block";
    }
}
window.plusSlides = function (n, no) {
    showSlides(slideIndex[no] += n, no);
}
if ($("#mblViewCarousel").is(':visible')) {

    var loginHtml = $('#signInContainerCarousel').html();
    $('#signInContainerMbl').append(loginHtml);
    $("#signInContainerCarousel").empty();

    var slideIndex = [1, 1];
    var slideId = ["ss_mySlides"]
    showSlides(1, 0);
    showSlides(1, 1);
}


$('.carousel-inner.cc_Inner').click(function (e) {
    if ($('#errorBox').length) {
        $('#errorBox').css('display', 'none');
    }
    e.stopPropagation();
})
},{}],17:[function(require,module,exports){
$("select.contactUsDropDownData").change(function () {
    if ($(this).children("option:selected").val() == "Choose option") {
        $(".answer-container").hide();
    } else {
        var selectValue = $(this).children("option:selected").val();
        $(".answer-container").hide();
        $('[data-contactus="' + selectValue + '"]').show();

    }
});

$(window).on('load', function () {
    var currentYear = new Date().getFullYear();
    var copyrightNotice = $('<div id="copyright-notice" style="display: none;">&copy; ' + currentYear + ' Enbridge Inc.  All rights reserved.</div>');
    $('body').append(copyrightNotice);
});

},{}],18:[function(require,module,exports){
$(document).ready(function () {

    var $container = $("#storyContainer");
    if (!$container.length) {
        $container = $("#newsContainer");
    }
    if (!$container.length) {
        return;
    }

    var contentInnerSelector =
        $("#storyContainer").length
            ? "#storyContainerInner"
            : "#newsTileContainerInner";

    var state = {
        page: parseInt($container.data("page"), 10) || 1,
        pageSize: parseInt($container.data("pagesize"), 10) || 0,
        search: "",
        sort: "",
        categories: [],
        regions: [],
        years: [],
        contentRootId: $container.data("rootid") || "",
        contentType: $container.data("type") || "",
        isLoadMore: false
    };

    var isAjaxRunning = false;

    $(".our-story-filters #categoryDropdown .dropdown-menu-custom label input:first").prop("checked", true);
    $(".our-story-filters #categoryDropdown .dropdown-menu-custom label input:first").parent("label").addClass("selected");

    function isMobileView() {
        return window.innerWidth <= 767;
    }

    function getTotalPages() {
        return parseInt($("#loadMoreBtn").data("total-pages"), 10) || 1;
    }

    function updateLoadMoreVisibility() {
        if (!isMobileView()) {
            $("#loadMoreWrapper").hide();
            return;
        }

        var totalPages = getTotalPages();

        if (state.page >= totalPages) {
            $("#loadMoreWrapper").hide();
        } else {
            $("#loadMoreWrapper").show();
        }
    }

    function updateMultiSelectUI(dropdownId) {

        var $d = $(dropdownId);
        var $cb = $d.find("input[type='checkbox']");
        var $label = $d.find(".dropdown-label");
        var def = $label.data("default");

        var $items = $cb.filter(function () {
            return $(this).val() !== "All";
        });

        var selected = $items.filter(":checked");

        $cb.each(function () {
            $(this).closest("label").toggleClass("selected", $(this).is(":checked"));
        });

        var count = selected.length;
        var total = $items.length;

        if (count === 0) $label.text(def);
        else if (count === total) $label.text("All Selected");
        else if (count === 1) $label.text(selected.val());
        else $label.text(count + " Selected");
    }

    function loadContent() {

        if (isAjaxRunning) return;
        isAjaxRunning = true;

        $.ajax({
            url: "/api/Sitecore/ContentListing/GetContentListingItems",
            type: "POST",
            data: JSON.stringify(state),
            contentType: "application/json; charset=utf-8",

            success: function (html) {

                var $response = $("<div>").html(html);

                var hasResults =
                    $response.find(".news-body").length > 0 ||
                    $response.find(".js-news-card").length > 0 ||
                    $response.find(".story-card").length > 0;

                if (!hasResults) {
                    $(contentInnerSelector).html(html);
                    $("#loadMoreWrapper").hide();
                    $(".pagination-wrapper").hide();
                    state.isLoadMore = false;
                    return;
                }

                var $containerEl = $(contentInnerSelector);
                var $row = $containerEl.find(".row").first();
                var $newItems = $response.find(".story-block, .col-sm-6");

                var $loadMore = $("#loadMoreWrapper");

                if (state.isLoadMore && isMobileView()) {

                    var $target = $row.length ? $row : $containerEl;

                    if ($newItems.length) {
                        if ($loadMore.length) {
                            $newItems.insertBefore($loadMore);   
                        } else {
                            $target.append($newItems);
                        }
                    }

                } else {
                    $containerEl.html(html);
                }

                var $btn = $response.find("#loadMoreBtn");

                if ($btn.length) {
                    $("#loadMoreBtn")
                        .data("total-pages", $btn.data("total-pages"))
                        .data("current-page", $btn.data("current-page"));
                }

                var $status = $response.find(".mobile-pagination-status");

                if ($status.length) {
                    $("#loadMoreWrapper .mobile-pagination-status").replaceWith($status);
                }

                state.isLoadMore = false;

                updateLoadMoreVisibility();
            },

            complete: function () {
                isAjaxRunning = false;
            }
        });
    }

    function resetAndReload() {
        state.page = 1;
        state.isLoadMore = false;
        loadContent();
    }

    function collectCategories() {
        state.categories = [];
        $("#categoryDropdown input:checked").each(function () {
            var value = $(this).val();
            if (value && value.toLowerCase() !== "all") {
                state.categories.push(value);
            }
        });
    }

    function collectRegions() {
        state.regions = [];
        $("#regionDropdown input:checked").each(function () {
            var value = $(this).val();
            if (value) state.regions.push(value);
        });
    }

    function collectYears() {
        state.years = [];
        $("#yearDropdown input:checked").each(function () {
            var value = $(this).val();
            if (value) state.years.push(value);
        });
    }

    $(document).on("click", ".dropdown-toggle-btn", function (e) {
        e.stopPropagation();

        var $parent = $(this).closest(".custom-dropdown");
        var $menu = $parent.find(".dropdown-menu-custom");

        $(".dropdown-menu-custom").not($menu).removeClass("show");

        $menu.toggleClass("show");
    });

    $(document).on("click", function () {
        $(".dropdown-menu-custom").removeClass("show");
    });

    $(document).on("click", ".dropdown-menu-custom", function (e) {
        e.stopPropagation();
    });

    $(document).on("keypress", "#storySearch", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            state.search = $.trim($(this).val());
            resetAndReload();
        }
    });

    $(document).on("click", ".search-btn", function () {
        state.search = $.trim($("#storySearch").val());
        resetAndReload();
    });

    $(document).on("input", "#storySearch", function () {
        var value = $.trim($(this).val());
        if (value === "" && state.search !== "") {
            state.search = "";
            resetAndReload();
        }
    });

    $(document).on("change", "#categoryDropdown input", function () {

        var $dropdown = $(this).closest(".custom-dropdown");
        var $checkboxes = $dropdown.find("input[type='checkbox']");
        var $allCheckbox = $checkboxes.filter(function () {
            return $(this).val().toLowerCase() === "all";
        });

        if ($(this).val().toLowerCase() === "all") {
            $checkboxes.prop("checked", $(this).is(":checked"));
        } else {
            var allSelected =
                $checkboxes.not($allCheckbox).length ===
                $checkboxes.not($allCheckbox).filter(":checked").length;

            $allCheckbox.prop("checked", allSelected);
        }

        collectCategories();
        updateMultiSelectUI("#categoryDropdown");
        resetAndReload();
    });

    $(document).on("change", "#regionDropdown input", function () {
        collectRegions();
        updateMultiSelectUI("#regionDropdown");
        resetAndReload();
    });

    $(document).on("change", "#yearDropdown input", function () {
        collectYears();
        updateMultiSelectUI("#yearDropdown");
        resetAndReload();
    });

    $(document).on("click", "#sortDropdown .dropdown-item", function (e) {

        e.stopPropagation();

        $("#sortDropdown .dropdown-item").removeClass("selected");
        $(this).addClass("selected");

        state.sort = $(this).data("value");
        $("#sortLabel").text($(this).text());

        $("#sortDropdown").closest(".custom-dropdown")
            .find(".dropdown-menu-custom")
            .removeClass("show");

        resetAndReload();
    });

    $(document).on("click", ".page-link", function (e) {
        e.preventDefault();

        var page = parseInt($(this).data("page"), 10);
        if (!page) return;

        state.page = page;
        state.isLoadMore = false;

        loadContent();

        $("html, body").animate({
            scrollTop: $container.offset().top - 100
        }, 300);
    });

    $(document).on('click', '#loadMoreBtn', function (e) {

        e.preventDefault();

        if (!isMobileView()) return;
        if (isAjaxRunning) return;

        var totalPages = getTotalPages();

        if (state.page >= totalPages) {
            $("#loadMoreWrapper").hide();
            return;
        }

        state.page += 1;
        state.isLoadMore = true;

        loadContent();
    });

    $(document).on("click", ".btn-reset-filter", function (e) {

        e.preventDefault();

        $("#storySearch").val("");

        $(".custom-dropdown input").prop("checked", false);
        $(".custom-dropdown label").removeClass("selected");

        $(".dropdown-label").each(function () {
            $(this).text($(this).data("default"));
        });

        $("#sortLabel").text($("#sortLabel").data("default"));
        $("#sortDropdown .dropdown-item").removeClass("selected");

        state.search = "";
        state.sort = "";
        state.categories = [];
        state.regions = [];
        state.years = [];

        resetAndReload();
    });

    updateLoadMoreVisibility();

    $(window).on("resize", function () {
        updateLoadMoreVisibility();
    });
  
});
},{}],19:[function(require,module,exports){
$(document).ready(function () {
    if ($('.faq_container').length) {
        allFilter();
        clearBackground();

        // Add minus icon for collapse element which is open by default
        $(".collapse.in").each(function () {
            $(this)
                .siblings(".panel-heading")
                .find(".fa")
                .addClass("rotate");
        });

        // Toggle plus minus icon on show hide of collapse element
        $(".collapse")
            .on("show.bs.collapse", function () {
                $('.faq_container .panel-default .panel-heading .panel-title .fa').removeClass("rotate");
                $(this)
                    .parent()
                    .find(".fa")
                    .addClass("rotate");
                $otherPanels = $('.faq_container .panel-default');
                    $('.collapse', $otherPanels).removeClass('in');
            })
            .on("hide.bs.collapse", function () {
                $(this)
                    .parent()
                    .find(".fa")
                    .removeClass("rotate");
            });
  
       
    }


})



window.clearBackground = function () {
    var filters = $('[id^="filter"]');
    for (var i = 0; i < filters.length; i++) {
        filters[i].style.background = 'transparent';
    }
}

window.clearRegionBackground = function () {
    var filters = $('[id^="locationfilter"]');
    for (var i = 0; i < filters.length; i++) {
        filters[i].style.background = 'transparent';
    }
}

window.allFilter = function () {
    clearBackground();
    $('#filter0').css('background-color', '#cccccc');

    var accordianList = $('[id^="Accordion_"]');

    for (var i = 0; i < accordianList.length; i++) {
        accordianList[i].style.display = 'block';
    }

   
}

window.faqFilter = function (id) {

    clearBackground();

    $('#' + id).css('background-color', '#cccccc');

    var accordians = $('[id^="Accordion_"]');

    for (var i = 0; i < accordians.length; i++) {
        accordians[i].style.display = 'none';
    }

    var ids = id.split("filter");
    var activeAccordian = '#Accordion_' + ids[1];
    $(activeAccordian).show();    

}




///////////////// mobile ///////////////////////

$('#faqselect').on('change', function () {
    var selectedValue = this.value;
    if (selectedValue == "selected" || selectedValue == "all") {
        allFilter();
    }
    if (selectedValue.includes('option')) {
        var dropdownid = (selectedValue.split('option'))[1];
        
        console.log(dropdownid);        
        console.log('#Accordion_' + dropdownid); 

       var accordians = $('[id^="Accordion_"]');

       for (var i = 0; i < accordians.length; i++) {
            accordians[i].style.display = 'none';
        }


        var activeAccordian = '#Accordion_' + dropdownid;
        $(activeAccordian).show();
        
    }
    //else {
    //    var accordians = $('[id^="Accordion_"]');

    //    for (var i = 0; i < accordians.length; i++) {
    //        accordians[i].style.display = 'none';
    //    }

   // }
})
},{}],20:[function(require,module,exports){
$(document).ready(function () {

    window.scrollPageToTop = function () {
        $('html, body').animate({
            scrollTop: $("#newsTileContainer").offset().top - 20
        });
        NewsRoomPaginationStyle();
    }

    window.NewsRoomPaginationStyle = function () {

        if ($('.page-item.active').children().length > 0)
        {
            var activePageNo = $('.page-item.active').text();
            $('.page-item.active').children().replaceWith($('<span>').text(activePageNo));
        }
    }

    window.filterNews = function w(id, region, year) {
        if (region != '') {
            clearRegionBackground();
        }

        if (year != '') {
            clearBackground();
        }

        if (region === '') {
            region = $('#region-filter-selected').val();
        } else if (region === 'all') {
            region = '';
            $('#region-filter-selected').val(region);
        } else {
            $('#region-filter-selected').val(region);
        }

        if (year === '') {
            year = $('#year-filter-selected').val();
        } else {
            $('#year-filter-selected').val(year);
        }

        $('#' + id).css('background-color', '#D0D0CE');

        var sortOrder = $('#newssortselect').val();

        GetFilterNewsList(region, year, sortOrder);
    }

    window.GetFilterNewsList = function (region, year, sortorder) {
        var pageSize = 0;
        if (window.matchMedia("(max-width: 767px)").matches) {
            pageSize = 5;
        } else {
            pageSize = 10;
        }
        var ds = $("#newsDataSourceGuid").val();
        $.ajax({
            url: '/api/sitecore/Newsroom/GetFilterNews',
            dataType: "html",
            data: { region: region, year:year, sortOrder: sortorder, ds: ds, pageSize: pageSize },
            type: "GET",
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                toastr.error(err.message);
            },
            success: function (data) {
                $('#newsTileContainer').html(data);
                NewsRoomPaginationStyle();
            }
        });

    }
   
    if ($('.news_container').length) {
        GetFilterNewsList('', 'all', '');
        clearBackground();
        clearRegionBackground();
    }

});

$('#newsmobilesortselect').change(function () {
    var sortOrder = $(this).children("option:selected").val();
    var selectedYear = '';
    var selectedRegion = '';

    var year = $('#newsmobileselect').children("option:selected").val();
    if (year != 'selected')
        selectedYear = $('#newsmobileselect').children("option:selected").text().trim();

    if (selectedYear === 'Select')
        selectedYear = '';
    if (selectedYear === $("#allyearsnews").text().trim())
        selectedYear = 'all';
    else
        selectedYear = selectedYear;

    var region = $('#newsregionmobileselect').children("option:selected").val();
    if (region != 'selected')
        selectedRegion = $('#newsregionmobileselect').children("option:selected").text().trim();

    if (selectedRegion === 'Select' || selectedRegion === $("#alllocationnews").text().trim())
        selectedRegion = '';
    else
        selectedRegion = selectedRegion;

    GetFilterNewsList(selectedRegion, selectedYear, sortOrder);
});

$('#newssortselect').change(function () {
    var sortOrder = $(this).children("option:selected").val();
    var selectedYear = '';
    var selectedRegion = '';

    var filters = $('[id^="filter"]');
    if (filters.length) {
        for (var i = 0; i < filters.length; i++) {
            if ($(filters[i]).css('background-color') == 'rgb(208, 208, 206)') {
                if ($(filters[i]).text().toLowerCase().indexOf('all') == -1) {
                    selectedYear = $(filters[i]).text();
                }
                break;
            }
        }
    }

    var locationfilters = $('[id^="locationfilter"]');
    if (locationfilters.length) {
        for (var i = 0; i < locationfilters.length; i++) {
            if ($(locationfilters[i]).css('background-color') == 'rgb(208, 208, 206)') {
                if ($(locationfilters[i]).text().toLowerCase().indexOf('all') == -1) {
                    selectedRegion = $(locationfilters[i]).text();
                }
                break;
            }
        }
    }

    GetFilterNewsList(selectedRegion, selectedYear, sortOrder);
});

$('#newsregionmobileselect').on("change", function () {
    var selectedYear = $("#newsmobileselect").children("option:selected").text().trim();

    if (selectedYear == 'Select')
        selectedYear = '';
    if (selectedYear == $("#allyearsnews").text().trim())
        selectedYear = 'all';
    else
        selectedYear = selectedYear;

    //get selected sort order from dropdown
    var sortOrder = $('#newsmobilesortselect').val();
    if (sortOrder == 'selected')
        sortOrder = '';

    var selectedValue = $(this).children("option:selected").val();
    if (selectedValue == "selected") {
        GetFilterNewsList('', selectedYear, sortOrder);
    }
    if (selectedValue.includes('option')) {
        var region = $(this).children("option:selected").text().trim();

        if (region == $("#alllocationnews").text().trim()) {
            GetFilterNewsList('', selectedYear, sortOrder);
        } else {
            GetFilterNewsList(region, selectedYear, sortOrder);
        }

    }
});

$('#newsmobileselect').change(function () {
    var selectedRegion = $("#newsregionmobileselect").children("option:selected").text().trim();

    if (selectedRegion == 'Select' || selectedRegion == $("#alllocationnews").text().trim())
        selectedRegion = '';
    else
        selectedRegion = selectedRegion;

    var sortOrder = $('#newsmobilesortselect').val();
    if (sortOrder == 'selected')
        sortOrder = '';

    var selectedValue = $(this).children("option:selected").val();
    if (selectedValue == "selected") {
        GetFilterNewsList(selectedRegion, 'all', sortOrder);
    }
    if (selectedValue.includes('option')) {
        var year = $(this).children("option:selected").text().trim();

        if (year == $("#allyearsnews").text().trim()) {
            GetFilterNewsList(selectedRegion, 'all', sortOrder);
        } else {
            GetFilterNewsList(selectedRegion, year, sortOrder);
        }
    }
});

//This mehtod is used to call when Page Size list is changed
$("#pagesizelist").change(function (event) {
        var ds = $("#newsDataSourceGuid").val();
        $.ajax({
            url: '@Url.Action("GetFilterNews", "NewsRoom")', //"/Player/GetPlayersByTeam",
            dataType: "html",
            data: {
                page: 1,
                pageSize: $(this).val(),
                year: '@ViewBag.Year',
                sortOrder: '@ViewBag.SortOrder',
                ds: ds
            },
            type: "GET",
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                toastr.error(err.message);
            },
            success: function (data) {
                $('#newsTileContainer').html(data);
            }
        });
});
},{}],21:[function(require,module,exports){
"use strict";

if ($("#timeline-container").length) {
    $(document).ready(function () {
        $('.timeline-horizontal-hr').last().hide();
        $('.timeline-vertical-hr').last().hide();
       $('.timeline-panel').last().css({ 'padding-right': '0px' });
    });

}
},{}],22:[function(require,module,exports){
$(document).ready(function () {
    if ($(".vtab_container").length) { 
        const vtfilter = $('[id^="vtfilter_"]');
        vtfilter.each(function (index, el) {
            var selectedTab = $(el);
            var currentTab = $(selectedTab.attr("data-target"))
            selectedTab.on('keydown', function (currentTab, e) {
                const KEY_ENT = 13;
                const KEY_TAB = 9;
                if (e.keyCode == KEY_ENT) {
                    setTimeout(function (currentTab) { currentTab.focus(); }.bind(null, currentTab), 100)
                }
                if (e.keyCode == KEY_TAB) {
                    if ($(document.activeElement).parent()[0] == $('li:last-child', $(this).closest('ul'))[0])
                        $('.vtab_container .last_focusable_element').focus();
                    if (e.shiftKey) {
                        if ($(document.activeElement).parent()[0] != $('li:first-child', $(this).closest('ul'))[0]) {
                            $("button", $(this).parent().prev()).focus();
                            e.preventDefault();
                        }
                    }
                }            
                
            }.bind(this, currentTab))
            var focusableEls = $('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]', $(selectedTab.attr("data-target")));
            currentTab.on('keydown', handleKeyDownCurrentTab.bind(this, selectedTab, focusableEls));
            function handleKeyDownCurrentTab(selectedTab, focusableEls, e) {
                const KEY_TAB = 9;
                if (e.keyCode == KEY_TAB) {
                    if (e.shiftKey) {
                        if (focusableEls.length == 0 || ($(document.activeElement)[0] == focusableEls[0]) || $(document.activeElement)[0] == $(selectedTab.attr("data-target"))[0]) {
                            selectedTab.focus();
                            e.preventDefault();
                        }
                    } else {
                        var nextTab = selectedTab.parent().next();
                        if (nextTab.length && (focusableEls.length == 0 || ($(document.activeElement)[0] == focusableEls[focusableEls.length - 1]))) {
                            nextTab.children('button').focus();
                            e.preventDefault();
                        }
                    }                        
                }
            }
        })
        



        //var verticalTabsContent = $('[id^="vtmenu_"]');
        //for (var i = 0; i < verticalTabsContent.length; i++) {
        //    var vthtml = $(verticalTabsContent[i]).html();
        //    var tabId = $(verticalTabsContent[i]).attr('id');
        //    var ids = tabId.split("vtmenu_");
        //    var vtmblTabId = '#tabpanel_' + ids[1];
        //    $(vtmblTabId).append(vthtml);
        //}

        var hash = document.location.hash;
        if (hash) {
           var tabToOpen="#"+$('button[data-target="'+hash+'"]').attr('id')
            try {
                $(".vtab_container " + tabToOpen).tab('show');  
                $('[id^="chevron_"]', $(tabToOpen).parent().siblings('li')).hide();
                $(tabToOpen).siblings('.fa.fa-caret-right').show();
            }
            catch (e) {
                console.log(e);
            }  
            var Guid = $('button[data-target="' + $(hash).closest(".tab-pane").attr("id") + '"]').attr('id')
            var GuidVal = "#" + Guid;
            try {
                $(".vtab_container " + GuidVal).tab('show');  
                $('[id^="chevron_"]', $(GuidVal).parent().siblings('li')).hide();
                $(GuidVal).siblings('.fa.fa-caret-right').show();
            }
            catch (e) {
                console.log(e);
            }
        }
    }
    
});

$(window).on('load', function () {
    if ($('#verticalTabMobileView').length) {
        $('#verticalTabMobileView .panel-heading').removeClass('active');
    }
    var vTabDesktop = $('.row', $('.vtab_container')).first();
    if (vTabDesktop.is(":hidden")) {
        vTabDesktop.empty();
    }
    vTabDesktop = null;
    var vTabMobile = $('#verticalTabMobileView');
    if (vTabMobile.is(":hidden") || $('#myTab-accordion.panel-group', vTabMobile).is(":hidden")) {
        vTabMobile.empty();
    }
    vTabMobile = null;
});
window.addActiveClassToVT = function (id) {
    var ids = id.split("_");
    var renderingId = ids[1];
    var tabId = ids[2];
    $('[id^="vtmenu_' + renderingId+'"]').each(function () {
        $(this).removeClass('active');
    });
    $('[id^="vtfilter_' + renderingId + '"]').each(function () {
        $(this).removeClass('active');
        $(this).parent().removeClass('active');
    });

    var vtabs = $('[id^="chevron_' + renderingId + '"]');
    for (var i = 0; i < vtabs.length; i++) {
        vtabs[i].style.display = 'none';
    }

    var activeTab = '#chevron_' + renderingId + '_' + tabId;
    $(activeTab).show();
    var selectedTab = $('#'+id);
    //set active
    var currentTab = $(selectedTab.attr("data-target"))
    currentTab.addClass("active");
    selectedTab.parent().addClass("active");
}
},{}],23:[function(require,module,exports){

    (function () {
        function validateRatePostalCode(postalCode) {
            var regexPostalCode = RegExp('[K-NP-Pk-np-p][0-9][A-Za-z]( |-|)[0-9][A-Za-z][0-9]');
            return regexPostalCode.test(postalCode);
        }
        window.Parsley.addValidator('validateRatePostalCode', {
        validateString: function validateString(postalCode, req, elem) {
                return validateRatePostalCode(postalCode);
            }
        });
        function removeSpaceAndHyphen(postalcode) {
                if (postalcode.indexOf(" ") != -1) {
                    postalcode = postalcode.split(" ");
                    var newPostalCode='';
                    for(var i=0;i<postalcode.length;i++)
                        newPostalCode = newPostalCode + postalcode[i];
                    postalcode=newPostalCode;
                }
                if (postalcode.indexOf("-") != -1) {
                    postalcode = postalcode.split("-");
                    var newPostalCode='';
                    for(var i=0;i<postalcode.length;i++)
                        newPostalCode = newPostalCode + postalcode[i];
                    postalcode=newPostalCode;
                }
                return postalcode;
            }
        $("#btn-ratepostalcode-submit").click(function (e) {
        e.preventDefault();
            $("#frm-ratepostalcode").parsley().validate();
            if ($("#frm-ratepostalcode").parsley().isValid()) {
                var domainName = document.location.protocol + "//" + document.location.hostname;
                var requestURL = domainName + "/api/sitecore/RateLookup/getrates";
                var requestData = { };
                requestData.__RequestVerificationToken = $("#frm-ratepostalcode input[name=__RequestVerificationToken]").val();
                requestData.postalCode = removeSpaceAndHyphen($("#RatePostalcode").val());
                requestData.rateFolderId = $("#RateFolderId").val();
                requestData.rateType = $("#RateType").val();
                $.ajax({
                    type: 'POST',
                    url: requestURL,
                    data: requestData,

                    'success': function success(result, status, xhr) {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            if (result.IsRateFound) {
                                $("#rateInsideOurService").css('display', 'none')
                                $("#rateOutsideOurService").css('display', 'none')
                                var newTab = window.open(result.RateLink, '_blank');
                                if (!newTab || newTab.closed || typeof newTab === 'undefined') {
                                    var alertMessage = "If the link does not open in a new tab, it may be blocked by your browser. Please allow popups for this site or click the button below to open the link manually.";
                                    $('<div></div>').appendTo('body')
                                        .html(alertMessage)
                                        .dialog({
                                            modal: true,
                                            title: 'Pop-up blocked',
                                            width: 'auto',
                                            buttons: {
                                                "View rate information": function () {
                                                    window.open(result.RateLink, '_blank');
                                                    $(this).dialog("closed");
                                                }
                                            },
                                            close: function () {
                                                $(this).dialog("destroy").remove();
                                            }
                                        });
                                }
                            } else {
                                $("#rateOutsideOurService").css('display', 'block')
                                $("#rateInsideOurService").css('display', 'none')
                            }

                        }
                    },
                    'error': function error() {
                        console.log('error')
                    }
                });
            }
        })
    })();
 
},{}],24:[function(require,module,exports){

    (function () {
        function validateServicePostalCode(postalCode) {
            var regexPostalCode = RegExp('[K-NP-Pk-np-p][0-9][A-Za-z]( |-|)[0-9][A-Za-z][0-9]');
            return regexPostalCode.test(postalCode);
        }
        window.Parsley.addValidator('validateServicePostalCode', {
        validateString: function validateString(postalCode, req, elem) {
                return validateServicePostalCode(postalCode);
            }
        });
        function removeSpaceAndHyphen(postalcode) {
                if (postalcode.indexOf(" ") != -1) {
                    postalcode = postalcode.split(" ");
                    var newPostalCode='';
                    for(var i=0;i<postalcode.length;i++)
                        newPostalCode = newPostalCode + postalcode[i];
                    postalcode=newPostalCode;
                }
                if (postalcode.indexOf("-") != -1) {
                    postalcode = postalcode.split("-");
                    var newPostalCode='';
                    for(var i=0;i<postalcode.length;i++)
                        newPostalCode = newPostalCode + postalcode[i];
                    postalcode=newPostalCode;
                }
                return postalcode;
        }

        $('#ServicePostalcode').focus(function (e) {
            $('#insideOurService').css('display', 'none');
            $('#outsideOurService').css('display', 'none');
        })

        $("#btn-servicepostalcode-submit").click(function (e) {
        e.preventDefault();
            $("#frm-servicepostalcode").parsley().validate();
            if ($("#frm-servicepostalcode").parsley().isValid()) {
                var domainName = document.location.protocol + "//" + document.location.hostname;
                var requestURL = domainName + "/api/sitecore/serviceareavalidate/validate";
                var requestData = { };
                requestData.__RequestVerificationToken = $("#frm-servicepostalcode input[name=__RequestVerificationToken]").val();
                requestData.postalCode = removeSpaceAndHyphen($("#ServicePostalcode").val());
                $.ajax({
                    type: 'POST',
                    url: requestURL,
                    data: requestData,
                                     
                    'success': function success(result, status, xhr) {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            if (result.IsInServiceArea) {
                                $("#insideOurService").css('display', 'block')
                                $("#outsideOurService").css('display', 'none')
                            } else {
                                $("#insideOurService").css('display', 'none')
                                $("#outsideOurService").css('display', 'block')
                            }
                        }
                    },
                    'error': function error() {
                        console.log('error')
                    }
                });
            }
        })
    })();
 
},{}],25:[function(require,module,exports){
"use strict";
if ($("#operationalstatusicon-container").length) {

    window.onIconScriptLoad = function () {

        var reCaptchaDisabled = $("#captcha_key").val() == null || $("#captcha_key").val() == undefined,
            $loading = '<div><img src="/images/ajax-loader.gif" /></div>',
            $iconApi = $('#icon_api_url').val(),
            $captcha_key = $('#captcha_key').val(),
            $trafficLightSummary = jQuery(".SystemIndicator");

            $trafficLightSummary.block({
                message: $loading,
                css: { border: 'none', backgroundColor: 'transparent' },
                overlayCSS: { backgroundColor: '#fff' }
            });
       
        if (!reCaptchaDisabled) {
            grecaptcha.ready(function () {
                var siteKey = $captcha_key;
                grecaptcha.execute(siteKey, { action: 'operationalstatusicon' }).then(function (token) {
                        userVerified(token);
                    
                });
            });
           
            function userVerified(token) {
                $('body').css("pointer-events", "auto");
                var url = $iconApi + '?captchaResponse=' + token;
                var req = $.ajax({
                    dataType: "jsonp",
                    type: "get",
                    url: url,
                    success: function (response, textStatus) {
                        var tomorrow = 2,
                            colour = response[tomorrow].Colour;
                        //retrieve tomorrow's gas day colour (green, red, or yellow)
                        $('#default').css("display", "none")
                        $("#" + colour).css("display", "inline-block");
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        $trafficLightSummary.unblock();
                    },
                    always: function () {
                        $trafficLightSummary.unblock();
                      /*  window.grecaptcha.reset();*/
                        $('body').css("pointer-events", "auto");
                    }
                });
                setTimeout(function () { req.abort(); }, 15000);
                
            }
        } else {
            //if captcha is disabled, default icon will be shown
        }
    }
}

},{}],26:[function(require,module,exports){
"use strict";

window.onTLScriptLoad = function () {

    var reCaptchaDisabled = $("#captcha_key").val() == null || $("#captcha_key").val() == undefined,
        $captcha_key = $('#captcha_key').val();
   
    var siteKey = $captcha_key;
        if (!reCaptchaDisabled) {// if recaptcha is not disabled
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'opStatus' }).then(function (token) { 
                        userVerified(token);                   
                });
            });

        function userVerified(token) {
            //callback after captcha is executed
            $('body').css("pointer-events", "auto");
            

            var requestData = {};
            requestData.__RequestVerificationToken = $("input[name=__RequestVerificationToken]").val();
            requestData.RecaptchaResponse = token;
            

            var req = $.ajax({
                url: '/api/TrafficLights/GetTrafficLights',
                type: 'POST',
                data: requestData,
                success: function (data) {
                    $('#opStatus').html(data);
                },
                error: function (error) {
                    //error
                    $('#tl-error-msg').html("Traffic Light is currently unavailable");
                    $('#tl-error-msg').css("display", "inline-block");
                }
            })
            setTimeout(function () { req.abort(); }, 15000);
        };

    } else { //if recpatcha is disabled
        //error
        $('#tl-error-msg').html("Traffic Light is currently unavailable");
        $('#tl-error-msg').css("display", "inline-block");
    }
}


window.checkCaptchaWindow = function () {
    //check if captcha puzzle is displayed
    const targetElement = document.body,
        observerConfig = {
            childList: true,
            attributes: false,
            attributeOldValue: false,
            characterData: false,
            characterDataOldValue: false,
            subtree: false
        };

    function DOMChangeCallbackFunction(mutationRecords) {
        mutationRecords.forEach((mutationRecord) => {
            if (mutationRecord.addedNodes.length) { //check only when notes were added to DOM
                var reCaptchaParentContainer = mutationRecord.addedNodes[0];
                var reCaptchaIframe = reCaptchaParentContainer.querySelectorAll('iframe[title*="recaptcha"]');

                if (reCaptchaIframe.length) { // Google reCaptcha iframe was loaded
                    // We don't want to observe more DOM changes for better performance
                    // Challenge was loaded -- DO SOMETHING HERE
                    reCaptchaObserver.disconnect();

                    new MutationObserver(x => reCaptchaParentContainer.style.opacity == 1 && onCaptchaParentView()) //check is captcha parent container is visible
                        .observe(reCaptchaParentContainer, { attributes: true, attributeFilter: ['style'] })

                    function onCaptchaParentView() {
                        $('body').css("pointer-events", "none");
                        $(reCaptchaParentContainer).css("pointer-events", "none");
                        $(reCaptchaIframe).css("pointer-events", "auto");
                    }

                }
            }
        });
    }

    const reCaptchaObserver = new MutationObserver(DOMChangeCallbackFunction);
    reCaptchaObserver.observe(targetElement, observerConfig);

}

if ($("#trafficlights-container").length) {

        $(window).on('load', function () {
            window.dialogMapComponent = null;
            $('.mapComponent .mapModal.modal').on('shown.bs.modal', function () {
                window.dialogMapComponent = new Dialog($(this), null)
                window.dialogMapComponent.open();
            });
            $('.mapComponent .mapModal.modal').on('hidden.bs.modal', function () {
                if (window.dialogMapComponent != null) {
                    window.dialogMapComponent.close();
                    window.dialogMapComponent = null;
                }
            })
            var individualLocations = $('.distributionServiceArea .individualLocation');
            individualLocations.each(function () {
                if ($('.mapCell .mapComponent', $(this)).length) {
                    $(this).next('.mobileMapLauncher').addClass('showLauncher');
                    var mapMobile = $('.mapCell .mapComponent .mapMobile', $(this))
                    if (mapMobile.length) {
                        $('.viewMapHolder', $(this).next('.mobileMapLauncher')).html(mapMobile.html());
                        mapMobile.empty()
                    }
                    mapMobile = null;
                }

            })
            individualLocations = null;
        })


        $(document).ready(function () {
            $('#accordion').on('show.bs.collapse', function () {
                $(this).find('.in').collapse('hide').parent().find('.accordion-heading .fa').toggleClass('fa-caret-up fa-caret-down');
            });
            $('#accordion').on('click', '.accordion-heading', function () {
                $(this).find('.fa').toggleClass('fa-caret-up fa-caret-down');
            });
        });


        window.ShowHideDetails = function (c, i, j, k, l, tableid) {
            var $class = c;
            var $idTlStr = "tl" + i + "-breakdown" + j + "-location" + k + "-status" + l;
            var $idStr = "data" + i + "-breakdown" + j + "-location" + k + "-status" + l;
            var $tl = $('#' + $idTlStr);
            var $id = $('#' + $idStr);
            HideDetails($idTlStr, $idStr, tableid);

            if (!$tl.hasClass($class))
                $tl.addClass($class);
            else
                $tl.removeClass($class);

            if (!$id.is(':visible'))
                $id.show();
            else
                $id.hide();
        }

        window.HideDetails = function (data, tl, tableid) {

            var $rows = $('#' + tableid + ' tr.traffic-signal');
            var $rowstd = $('#' + tableid + ' td.traffic-signal');

            var $tl = $('#' + data);
            var $id = $('#' + tl);

            $rows.each(function (i, row) {
                if ($(this).attr("id") != $id.attr("id"))
                    $(this).hide();

            });
            $rowstd.each(function (i, row) {
                if ($(this).attr("id") != $tl.attr("id"))
                    $(this).removeClass("warning success danger");
            });
        }
    }



},{}],27:[function(require,module,exports){
//var $ = require("jquery");
function escapeHtml(text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function (m) { return map[m]; });
}
//var parsley = require("parsleyjs");

//add a change trigger for all form elements so that it is validated client side as soon as value is changed
$("input").attr("data-parsley-trigger", "change");

//if (localStorage != null && localStorage.chkbx && localStorage.chkbx != "") {
//    var usernameQuery = $('.signin-username');
//    var rememberChkbx = $('.rememberme');
//    for (var i = 0; i < usernameQuery.length; i++) {
//        usernameQuery[i].value = localStorage.username;
//        rememberChkbx[i].checked = true;
//    }

//} else {
//    var usernameQuery = document.querySelectorAll("[class='signin-username']");
//    var rememberChkbx = document.querySelectorAll("[class='rememberme']");
//    for (var i = 0; i < usernameQuery.length; i++) {
//        usernameQuery[i].value = "";
//        rememberChkbx[i].checked = false;
//    }

//}


//$(document).on("click", ".rememberme", function () {
//    if ($(this).is(":checked")) {
//        var signinUname = $(this)
//            .closest(".form-group")
//            .siblings()
//            .find(".signin-username")
//            .val();
//        try {
//            localStorage.setItem("username", signinUname);

//            localStorage.setItem("chkbx", $(this).val());

//            console.log(localStorage.username);
//        } catch (e) {
//            console.log(e);
//        }
//    } else {
//        try {
//            localStorage.setItem("username", "");
//            localStorage.setItem("chkbx", "");
//        } catch (e) {
//            console.log(e);
//        }
//    }
//});


//$(document).on("keypress", ".integerLength", function (e) {
//    //if the letter is not digit then display error and don't type anything
//    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
//        //display error message
//        return false;
//    }
//});
//$(document).on("keypress", ".date-check,.chk-prev,.moveDates", function (e) {
//    if (e.which != 8 && e.which != 0 && e.which != 45 && (e.which < 48 || e.which > 57)) {
//        //display error message
//        return false;
//    }

//});

//$(document).on("keyup", ".date-check,.chk-prev", function (e) {
//    if ($(this).val() == "") {
//        if (e.which === 9) {
//            return true;
//        } else {
//            $(this).parsley().reset();
//            $(this).parsley().validate();
//            var errorObj = $(this).parent().find(".parsley-errors-list");
//            if ($(errorObj).length > 1) {
//                $(errorObj[1]).remove();
//                if ($(errorObj[0]).find("li").length > 1) {
//                    $(errorObj[0]).find("li")[0].remove();
//                }
//            } else {
//                if ($(errorObj).find("li").length > 1) {
//                    $(errorObj).find("li")[0].remove();
//                }
//            }
//        }
//    }
//});

//$(document).on("keyup", "input[type=password]", function (e) {
//    if ((e.keyCode == 8 && $(this).val() == "") && ($(this).attr("data-parsley-equalto") == "" || $(this).attr("data-parsley-equalto") == undefined)) {
//        $(".pwd-info-chklist li").each(function () {
//            $(this).removeClass("valid").addClass("invalid");
//        })
//    }

//});
//$(document).on("focusout", ".date-check", function (e) {

//    var inputValues = $(this).val();
//    if (inputValues != "") {
//        var dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
//        if ($(this).val().match(dateReg)) {
//            var today = new Date();

//            var date = inputValues.split('-')[2] + '-' + inputValues.split('-')[1] + '-' + inputValues.split('-')[0];
//            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
//            var formattednewDate = new Date(date + ' ' + time);

//            var d1 = new Date();
//            var parts = inputValues.split("-");
//            var returnDate = parts[1] + "/" + parts[0] + "/" + parts[2];
//            var d2 = new Date(returnDate);
//            var dif = parseInt(d2.getTime() - d1.getTime());
//            var diffdays = (dif / 1000 / 60 / 60 / 24);

//            if (diffdays < 0 && parseInt(diffdays) != 0) {
//                $(this).parsley().removeError('forcederror', { updateClass: true });
//                $(this).parsley().addError('forcederror', { message: 'Please select  a valid date.', updateClass: true });


//            } else {
//                $(this).removeClass("parsley-error");
//                $(this).parsley().removeError('forcederror', { updateClass: true });

//            }


//            var formattedDate = inputValues.split("-");
//            if (formattedDate.length >= 3) {
//                var date = formattedDate[0];
//                var month = formattedDate[1];
//                var year = formattedDate[2];

//                var dateCheck = /^(0?[1-9]|[12][0-9]|3[01])$/;
//                var monthCheck = /^(0[1-9]|1[0-2])$/;
//                var yearCheck = /^\d{4}$/;

//                if (month.match(monthCheck) && date.match(dateCheck) && year.match(yearCheck)) {

//                    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

//                    if (month == 1 || month > 2) {
//                        if (date > ListofDays[month - 1]) {
//                            alert('Invalid date format!');
//                            return false;
//                        }
//                    }

//                    if (month == 2) {
//                        var leapYear = false;
//                        if ((!(year % 4) && year % 100) || !(year % 400)) {
//                            leapYear = true;
//                        }

//                        if ((leapYear == false) && (date >= 29)) {
//                            $(this).parsley().addError('forcederror', { message: 'Please select  a valid date', updateClass: true });
//                        }

//                        if ((leapYear == true) && (date > 29)) {
//                            $(this).parsley().addError('forcederror', { message: 'Please select  a valid date', updateClass: true });
//                        }

//                    }
//                    var flag = 1
//                }

//                else {
//                    var errorObj = $(this).parent().find(".parsley-errors-list");
//                    if ($(errorObj).find("li").length >= 1) {
//                        $(errorObj).find("li").remove();
//                    }
//                    $(this).parsley().addError('forcederror', { message: 'Please select  a valid date', updateClass: true });

//                }
//                if (flag == 1) {
//                }
//            } else {
//                var errorObj = $(this).parent().find(".parsley-errors-list");
//                if ($(errorObj).find("li").length >= 1) {
//                    $(errorObj).find("li").remove();
//                }
//                $(this).parsley().addError('forcederror', { message: 'Please select  a valid date', updateClass: true });
//                $(this).focus();
//            }
//        }
//        else {
//            if ($(this).find(".date-check").hasClass("parsley-error")) {
//                $(this).find(".date-check").parsley().removeError('forcederror', { updateClass: true });
//            }
//            $(this).parent().find("ul").removeClass("filled");
//            $(this).parent().find("ul li").remove();
//            //}
//            $(this).next("ul").find("li.parsley-forcederror").remove();

//            $(this).parsley().addError('forcederror', { message: 'Please select  a valid date', updateClass: true });
//            $(this).focus();
//        }
//    }
//    var len = $(this).parent().find(".parsley-errors-list").length;
//    if (len > 1) {
//        var errorlist = $(this).parent().find(".parsley-errors-list");
//        for (var i = 1; i <= len; i++) {
//            $(errorlist[i]).remove();
//        }
//        var lilen = $(this).parent().find(".parsley-errors-list li").length;
//        var errorlistli = $(this).parent().find(".parsley-errors-list li");
//        if (lilen > 1) {

//            for (var i = 1; i <= lilen; i++) {
//                $(errorlistli[i]).remove();
//            }
//        }
//    }

//});
//$(document).on("focusout", ".chk-prev", function (e) {

//    var inputValues = $(this).val();
//    if (inputValues != "") {
//        var dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
//        if ($(this).val().match(dateReg)) {
//            var formattednewDate = new Date(inputValues.split('-')[2], inputValues.split('-')[1] - 1, inputValues.split('-')[0]);
//            var d = new Date();
//            var parentsID = $(this).parent().attr("id");
//            var d1 = new Date();
//            var parts = inputValues.split("-");
//            var returnDate = parts[1] + "/" + parts[0] + "/" + parts[2];
//            var d2 = new Date(returnDate);
//            var dif = parseInt(d2.getTime() - d1.getTime());
//            var diffdays = (dif / 1000 / 60 / 60 / 24);

//            if (diffdays > 0 && parseInt(diffdays) != 0) {
//                $(this).parsley().removeError('doberror', { updateClass: true });
//                $(this).parsley().addError('doberror', { message: 'Please select a valid date.', updateClass: true });

//            } else {
//                $(this).removeClass("parsley-error");
//                $(this).parsley().removeError('doberror', { updateClass: true });

//            }

//            var formattedDate = inputValues.split("-");
//            if (formattedDate.length >= 3) {
//                var date = formattedDate[0];
//                var month = formattedDate[1];
//                var year = formattedDate[2];

//                var dateCheck = /^(0?[1-9]|[12][0-9]|3[01])$/;
//                var monthCheck = /^(0[1-9]|1[0-2])$/;
//                var yearCheck = /^\d{4}$/;

//                if (month.match(monthCheck) && date.match(dateCheck) && year.match(yearCheck)) {

//                    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

//                    if (month == 1 || month > 2) {
//                        if (date > ListofDays[month - 1]) {
//                            $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//                            return false;
//                        }
//                    }

//                    if (month == 2) {
//                        var leapYear = false;
//                        if ((!(year % 4) && year % 100) || !(year % 400)) {
//                            leapYear = true;
//                        }

//                        if ((leapYear == false) && (date >= 29)) {
//                            $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//                        }

//                        if ((leapYear == true) && (date > 29)) {
//                            $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//                        }

//                    }
//                    var flag = 1
//                }

//                else {
//                    var errorObj = $(this).parent().find(".parsley-errors-list");
//                    if ($(errorObj).find("li").length >= 1) {
//                        $(errorObj).find("li").remove();
//                    }
//                    $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//                }
//            }

//            else {
//                if ($(this).find(".chk-prev").hasClass("parsley-error")) {
//                    $(this).find(".chk-prev").parsley().removeError('doberror', { updateClass: true });
//                }
//                $(this).parent().find("ul").removeClass("filled");
//                $(this).parent().find("ul li").remove();
//                //}
//                $(this).next("ul").find("li.parsley-doberror").remove();

//                $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//                $(this).focus();
//            }
//        }
//        else {
//            if ($(this).find(".chk-prev").hasClass("parsley-error")) {
//                $(this).find(".chk-prev").parsley().removeError('forcederror', { updateClass: true });
//            }
//            $(this).parent().find("ul").removeClass("filled");
//            $(this).parent().find("ul li").remove();

//            $(this).next("ul").find("li.parsley-doberror").remove();

//            $(this).parsley().addError('doberror', { message: 'Please select a valid date', updateClass: true });
//            $(this).focus();
//        }
//        var len = $(this).parent().find(".parsley-errors-list").length;
//        if (len > 1) {
//            var errorlist = $(this).parent().find(".parsley-errors-list");
//            for (var i = 1; i <= len; i++) {
//                $(errorlist[i]).remove();
//            }
//            var lilen = $(this).parent().find(".parsley-errors-list li").length;
//            var errorlistli = $(this).parent().find(".parsley-errors-list li");
//            if (lilen > 1) {

//                for (var i = 1; i <= lilen; i++) {
//                    $(errorlistli[i]).remove();
//                }
//            }
//        }
//    }
//});
$(document).on("click", ".custom-radio-button input, .individual-category input", function () {
    $(this).parsley().validate();
})
$(document).ready(function () {

    $(".error-box").hide();
    //call parsley on forms, set options so that validation and error warnings appear
    //$("form").parsley();

    // Convenience members
    $.validationErrors = {
        container: $(".error-box"),

        list: $(".catch-errors"),

        updateContainer: function () {
            // Hide/show container if list is empty/full
            $.validationErrors.container.toggleClass(
                "filled",
                $.validationErrors.container.find("p:first").length > 0
            );
        },

        removeItem: function (sFieldName) {
            // Remove related error messages from list
            $(".error-box")
                .find('p[data-related-field-name="' + sFieldName + '"]')
                .remove();
        },
        filterVal: function (closestDiv, messages, ParsleyField) {
            var test = $(closestDiv.find("p:contains(" + messages + ")"));

            if (test.length > 0) {
                return false;
            } else {
                var fieldName = ParsleyField.$element.attr("id");
                if (!ParsleyField.$element.attr("data-parsley-excluded")) {
                    var $m = $(
                        '<p data-related-field-name="' +
                        fieldName +
                        '">' +
                        messages +
                        "</p>"
                    );
                    $(".error-box").append($m);
                }
            }
        }
    };

    // Before each validation, clear the validation-errors of the div
    window.Parsley.on("form:validate", function (e) {
        $.validationErrors.container.html();

        $("form")
            .parent()
            .find(".error-box")
            .show();
        $("form")
            .parent()
            .find(".error-box")
            .html("");
        var formID = $(this)
            .parent()
            .find("form")
            .attr("id");
        $("#" + formID).parsley("validate");
        $(".error-box").append(
            "<h2>The following errors prevented this form from being submitted:</h2>"
        );
    });

    // When a field has an error
    window.Parsley.on("field:error", function (e) {
        // Get the error messages
        if (!e.$element.attr("data-parsley-excluded")) {
            var messages = e.getErrorsMessages();
        }
        else {
            if (e._ui.$errorsWrapper.find("li").length > 1) {
                e._ui.$errorsWrapper.find("li").remove();
                e._ui.$errorsWrapper.css('display', 'none');
                e.validationResult = false;
                return false;
            } else if (e._ui.$errorsWrapper.find("li").hasClass("parsley-required")) {

                e._ui.$errorsWrapper.css('display', 'block');
            }

        }
        var ss = $(".parsley-required");
        if (ss.length > 0) {
            for (var j = 0; j < ss.length; j++) {
                if (ss[j].childNodes[0] != null && ss[j].childNodes[0].className != "font-bold") {
                    var x = "";
                    x =
                        "<span class='font-bold'>Required field</span><br>This Field is Required. " +
                        ss[j].innerText;
                    ss[j].innerHTML = x;
                }
                var html = ss[j].innerHTML;
                ss[j].innerHTML = html.replace(new RegExp('<span class="font-bold">Required field</span><br>This Field is Required. '), '')
            }
        }

        // Loop through all the messages
        for (var i in messages) {
            var closest_errorBox = e.$element
                .closest("form")
                .siblings(".error-box");
            $.validationErrors.filterVal(closest_errorBox, messages[i], e);
        }
        $.validationErrors.updateContainer();
    });

    window.Parsley.on("field:success", function (e) {

        if (e.$element.hasClass("date")) {
            $.validationErrors.removeItem(e.$element.find(".form-control").attr("id"));
        } else {
            $.validationErrors.removeItem(e.$element.attr("id"));
        }
        $.validationErrors.updateContainer();
        var dd = e.$element.closest("form").siblings(".error-box");
        if (dd.children().length <= 1) {
            $(".error-box").hide();
        }
    });


    // When there's a click on a error message from the div
    $(document).on("click", "a[data-related-field-name]", function () {
        // take the field's name from the attribute
        var name = $(this).attr("data-related-field-name");
        $("[name=" + name + "]").focus();
    });

    $(".menu-icon").click(function () {
        var src = $(this).attr("src");
        var newsrc =
            src == "/images/icon-menu.svg"
                ? "/images/icon-close-menu.svg"
                : "/images/icon-menu.svg";
        $(this).attr("src", newsrc);
    });

    //for back to top fucntionality
    $(window).bind("scroll", function () {
        if ($(this).scrollTop() > 100) {
            $(".back-to-top").fadeIn(400);
        } else {
            $(".back-to-top").fadeOut(400);
        }
    });

    $(".back-to-top").click(function () {
        $("html, body").animate({ scrollTop: "0px" }, 1000)
            .promise().then(function () {
                window.location.hash = "";
                window.location.hash = "#back-to-top";
            });
    });

    $(".calculate-btn").click(function () {
        $(".estimated-amount").show();
    });

    $(".dropdown-view > a").removeAttr("href");

    $(".dropdown-view > a").attr("tabindex", 0);

    $(".sub-nav .dropdown-toggle").on("keyup", function (e) {
        var element = $(this);
        if (e.keyCode == 32 || e.charCode == 32 || e.keyCode == 13) {
            e.preventDefault();
            $(".sub-nav .dropdown-menu").toggle();
        }
    });
    $(".sub-nav .dropdown-menu li a:last").on("keypress", function (e) {
        console.log(e.keyCode + "  " + e.which + "   " + e.charCode);
        if (e.keyCode == 9 && !e.shiftKey) {
            $(".sub-nav .dropdown-menu").toggle();
        }
    });

    $(".sub-nav .nav-tabs .dropdown-menu li").on("click", function () {
        $(this).addClass('dropdown-tick').siblings().removeClass('dropdown-tick');
    });
});


},{}],28:[function(require,module,exports){
//function entersubmit(field, e) {
//    var keycode;
//    if (window.event) keycode = window.event.keyCode;
//    else if (e) keycode = e.which;
//    else return true;
//    if (keycode == 13) {
//        //alert('hi');
//        if ($("#username").val() != "" && $("#password").val() != "") {

//            return false;
//        }
//    }
//    else
//        return true;
//}




$(window).on('load', function () {
    if ($('.panel-collapse')) {
        $($('.panel-collapse')[0]).prev(".panel-heading").addClass("active");
    }
    //$("body").css("opacity", "1");
});

$(document).ajaxSend(function (event, jqxhr, settings) {
    //var pageurl = ["/api/sitecore/mymove/GettingStarted/", "/api/ContactInfo/GetContactInfoPhoneNumbers", "/MovesCard", "/InsightsCard", "/api/sitecore/MyMove/AddressSearch", "/api/sitecore/MyMove/HouseNumberSearch", "/api/sitecore/AddressSearch/AddressSearch", "/api/sitecore/AddressSearch/HouseNumberSearch"];
    //var isurlExists = false;
    //for (i = 0; i < pageurl.length; i++) {
    //    var index = settings.url.toLowerCase().indexOf(pageurl[i].toLowerCase());
    //    if (index >= 0) {
    //        isurlExists = true;
    //        break;
    //    }
    //}
    //if (!isurlExists) {
        $("#div-global-loader-box").show();
    //}    

}).ajaxStop(function () {
    $("#div-global-loader-box").hide();
    $(".phone").mask("(999) 999-9999");
});

$(document).ready(function () {
    if ($(".myTab").length > 0) {
        var hash = document.location.hash;
        if (hash) {

            try {
                $(".myTab a[href=\\" + hash + "]").tab('show');
                $(".nav-tabs a[href=\\" + hash + "]").tab('show');

            }
            catch (e) {
                console.log(e);
            }
        }
        $(hash).collapse("show");
        var Guid = $(hash).closest(".tab-pane").attr("id");
        var GuidVal = "#" + Guid;
        try {
            $(".myTab a[href=\\" + GuidVal + "]").tab('show');
        }
        catch (e) {
            console.log(e);
        }
    }
    //var kubra_link = document.location.hash;
    //if (kubra_link == "kubrasite") {
    //    $(kubra_link).closest(".panel-default").find("a").trigger("focus");
    //    $(kubra_link).parent().parent().collapse("show");
    //}

    var newWindowWidth = $(window).width();

    //$(".download-list-pagination").change(function () {
    //    console.log($(this).val());
    //});

    //$(".exit-button-grey").click(function () {
    //    $(this)
    //        .closest(".mega-dropdown-menu")
    //        .removeClass("open-div");
    //});
    //if (newWindowWidth > 991) {
    //    $(".mega-dropdown").hover(
    //        function () {
    //            $(this)
    //                .find(".mega-dropdown-menu")
    //                .addClass("open-div");
    //            $(this)
    //                .find(".dropdown-toggle")
    //                .css("background-color", "white");
    //            $(this)
    //                .find(".dropdown-toggle")
    //                .css("color", "#353535");
    //        },
    //        function () {
    //            $(this)
    //                .find(".mega-dropdown-menu")
    //                .removeClass("open-div");
    //            $(this)
    //                .find(".dropdown-toggle")
    //                .css("background-color", "inherit");
    //            $(this)
    //                .find(".dropdown-toggle")
    //                .css("color", "white");
    //        }
    //    );
    //}
    if (newWindowWidth < 991) {
        $(".navbar-nav .dropdown .dropdown-toggle").attr("data-toggle", "dropdown");
    }
    //$(document).on("click", ".sign-in-box > a", function () {
    //    if ($(this).text() == "SIGN OUT") {
    //        $(this).text("SIGN IN");
    //    }
    //});
    /*$(".sign-in-box").hover(
      function () {
        if ($(this).find("a").eq(0).text() != "SIGN OUT") {
          $(this).find(".sign-in-container").addClass("open-signin");
          $(this).find("a").css("color", "#353535");
        }
  
      },
      function () {
        $(this).find(".sign-in-container").removeClass("open-signin");
        $(this).find("a").css("color", "white");
  
      }
    );*/

    //$('.sign-in-box > a').click(function (event) {
    //    $('.sign-in-box').toggleClass('active');

    //    if ($('.sign-in-box').hasClass('active')) {
    //        $('.sign-in-box').css('background-color', '#FFB81C');
    //        $('.sign-in-box').find("a").css('color', '#353535');
    //    } else {
    //        $('.sign-in-box').css('background-color', '#FFB81C');
    //        $('.sign-in-box').find("a").css('color', '#000000');
    //    }

    //    //$('.sign-in-box').css("background-color", "#FFB81C");
    //    //$('.sign-in-box').find("a").css("color", "#353535");
    //    $('.sign-in-container').toggle();
    //});

    //$(".account-icon,#account-signin,#account-signout").click(function () {
    //    if (!isUserLoggedin) {
    //        var src = $(this).attr("src");
    //        $(this)
    //            .parent()
    //            .addClass("yellow-bg");
    //        $(this).addClass("remove-bg");
    //        var newsrc =
    //            src == "/images/iconAccount.png"
    //                ? "/images/icon-close-menu.svg"
    //                : "/images/iconAccount.png";
    //        $(this).attr("src", newsrc);
    //        $(this)
    //            .parent()
    //            .find(".small-signIn-container")
    //            .addClass("open-signin");
    //        if (src == "/images/icon-close-menu.svg") {
    //            $(this)
    //                .parent()
    //                .find(".small-signIn-container")
    //                .removeClass("open-signin");
    //            $(this)
    //                .parent()
    //                .removeClass("yellow-bg");
    //        }
    //    }
    //    else {
    //        signOut();
    //    }
    //});


    /*$(document).on("change", ".help-category input[type=radio]", function (event) {
  
        //$(".sub-individual-category").hide();
        $(this).parent().siblings().removeClass('border2Px');
        $(this).parent().siblings().find('.individual-category').removeClass('border2Px').find('input').prop('checked', false);
        $(this).closest('.individual-category').addClass('border2Px');
  
        //$(this).parent().next('.sub-individual-category').show();
        $(this).closest('.individual-category').next('.sub-individual-category').addClass('dd');
        var test = $(this).closest('.sub-individual-category');
        if (test.hasClass('dd')) {
           event.preventDefault();
        } else {
           $('.individual-category').siblings().next('.sub-individual-category').hide();
           $(this).closest('.individual-category').next('.sub-individual-category').show();
        }
     });*/
    //$(document).on("change", ".help-category input[type=radio]", function (event) {
    //    //$(".sub-individual-category").hide();
    //    $(this)
    //        .parent()
    //        .siblings()
    //        .removeClass("border2Px");
    //    $(this)
    //        .parent()
    //        .siblings()
    //        .find(".individual-category")
    //        .removeClass("border2Px")
    //        .find("input")
    //        .prop("checked", false);
    //    $(this)
    //        .closest(".individual-category")
    //        .addClass("border2Px");

    //    //$(this).parent().next('.sub-individual-category').show();
    //    $(this)
    //        .closest(".individual-category")
    //        .next(".sub-individual-category")
    //        .addClass("dd");
    //    var test = $(this).closest(".sub-individual-category");
    //    if (test.hasClass("dd")) {
    //        event.preventDefault();
    //    } else {
    //        $(".individual-category")
    //            .siblings()
    //            .next(".sub-individual-category")
    //            .hide();
    //        $(this)
    //            .closest(".individual-category")
    //            .next(".sub-individual-category")
    //            .show();
    //    }
    //    var answer = $(this)
    //        .parent()
    //        .children(".answer")
    //        .html();
    //    if (answer != "" && answer != null) {
    //        if ($(this).val() == null || $(this).val() == "") {
    //            $(".gas-service-installation")
    //                .find(".help-context")
    //                .html(
    //                    $(this)
    //                        .parent()
    //                        .children(".help-category input[type=radio]")
    //                        .attr("name")
    //                );
    //        } else {
    //            $(".gas-service-installation")
    //                .find(".help-context")
    //                .html($(this).val());
    //        }
    //        $(".gas-service-installation")
    //            .find(".answer-wrapper")
    //            .html(answer);
    //        $(".gas-service-installation").css("display", "block");
    //    } else {
    //        $(".gas-service-installation")
    //            .find(".help-context")
    //            .html("");
    //        $(".gas-service-installation")
    //            .find(".answer-wrapper")
    //            .html("");
    //        $(".gas-service-installation").css("display", "none");
    //    }
    //});

    //$(document).on("change", ".contact-us-wrapper select", function (event) {
    //    if ($(this).attr("value") == "contactEmpty") {
    //        $(".answer").hide();
    //    }
    //    else {
    //        var selectValue = $(this).attr("value");
    //        $(".answer").hide();
    //        $(selectValue).show();
    //    }
    //});

    //$('input[name="other"]').click(function () {
    //    if ($(this).attr("id") == "NewGas15") {
            // $('.gas-service-installation').css('display','block');
    //    } else {
            //$('.gas-service-installation').css('display','none');
    //    }
    //});

    /* $('input[name="other"]').click(function() {
      if($(this).attr('id') == 'NewGas15') {
          $('.gas-service-installation').css('display','block');
      }
  
      else {
          $('.gas-service-installation').css('display','none');
      }
  });*/
    //$('input[name="help"]').click(function () {
        /*var inputValue = $(this).attr("id");
    
          var targetBox = "." + inputValue;
          $(".sub-individual-category").not(targetBox).hide();
          $(targetBox).show();*/
    //});

    //$('input[name="online"]').click(function () {
        /*var inputValue = $(this).attr("id");
    
          var targetBox = "." + inputValue;
          $(".sub-section-category").not(targetBox).hide();
          $(targetBox).show();*/
    //});
});
/***************************code for the date picker */



$(".date-container .dob")
    .datepicker({
        orientation: "bottom left",
        endDate: new Date()
    })
    .on("changeDate", function () {
        if ($(this).find(".chk-prev").val() != "") {
            if ($(this).find(".chk-prev").hasClass("parsley-error")) {
                $(this).find(".chk-prev").parsley().removeError('doberror', { updateClass: true });
                $(this).find(".chk-prev").removeClass("parsley-error");
                $(this).find("ul").removeClass("filled");
                $(this).find("ul li").remove();
            }
        } else {
            $(this).find("ul li.parsley-doberror").remove();
        }
        $(".datepicker").hide();
    });

$(".date-container .date")
    .datepicker({
        orientation: "bottom left",
        startDate: "01/01/2018" /*new Date()*/
    })
    .on("changeDate", function () {
        if ($(this).find(".date-check").val() != "") {
            if ($(this).find(".date-check").hasClass("parsley-error")) {
                $(this).find(".date-check").parsley().removeError('forcederror', { updateClass: true });
                $(this).find(".date-check").removeClass("parsley-error");
                $(this).find("ul").removeClass("filled");
                $(this).find("ul li").remove();
            }
        } else {
            $(this).find("ul li.parsley-forcederror").remove();
            //$(this).removeClass(parsley-error);
        }
        $(".datepicker").hide();
    });


/***************************code for the date picker ends */
//$("#budget-plan").click(function () {
//    var totalRows = $("#tblData").find("tbody tr:has(td)").length;
//    var recordPerPage = 10;
//    nBegin = 1;
//    nEnd = 10;
//    var totalPages = Math.ceil(totalRows / recordPerPage);
//    var $pages = $('<div id="pages"></div>');
//    var $rightalign = $(
//        '<div id="right-pages" class="col-md-12"><span> Page <span></div>'
//    );
//    var $pageslist = $("<span> of " + totalPages + "</span>");
//    var $drop = $('<select id="chkbk"></select>');
//    for (i = 0; i < totalPages; i++) {
//        $('<option class="pageNumber">&nbsp;' + (i + 1) + "</option>").appendTo(
//            $drop
//        );
//    }

//    $pages.insertAfter("#tblData");
//    paginationVal(nBegin, nEnd, totalRows).appendTo("#pages");

//    $rightalign.appendTo("#pages");

//    $drop.appendTo("#right-pages");
//    $pageslist.appendTo($rightalign);

//    $("table")
//        .find("tbody tr:has(td)")
//        .hide();
//    var tr = $("table tbody tr:has(td)");
//    for (var i = 0; i <= recordPerPage - 1; i++) {
//        $(tr[i]).show();
//    }
//    $("select").change(function (event) {
//        $("#tblData")
//            .find("tbody tr:has(td)")
//            .hide();
//        nBegin = ($("#chkbk option:selected").text() - 1) * recordPerPage;
//        nEnd = $("#chkbk option:selected").text() * recordPerPage - 1;
//        $("#left-pages").remove();
//        paginationVal(nBegin + 1, nEnd + 1, totalRows).appendTo("#pages");
//        for (var i = nBegin; i < nEnd; i++) {
//            $(tr[i]).show();
//        }
//    });
//});

//function paginationVal(nBegin, nEnd, totalRows) {
//    var $leftalign = $(
//        "<div id='left-pages' class='col-md-12'>Showing" +
//        nBegin +
//        " - " +
//        nEnd +
//        " of " +
//        totalRows +
//        " Accounts</div>"
//    );
//    return $leftalign;
//}

//$(document).on("click", ".msg-flyout > a, .pay-now > a", function () {
//    var $ = require("jquery");
//    var parsley = require("parsleyjs");
//    $(".error-box").hide();

//    setTimeout(function () {
//        $("body").css("padding-right", "0");
//        $("body").removeClass("modal-open");
//        $("body").css("background-color", "rgba(0, 0, 0, 0.65)");
//        //$('.modal-backdrop').remove();
//    }, 400);

//    //Re-Initializing validation in form
//    var curForm = $(this)
//        .parent()
//        .find("form")
//        .attr("id");
//    $("#" + curForm).parsley();
//});

$(document).on("click", ".modal .close", function () {
    try {
        //var $ = require("jquery");
        //var parsley = require("parsleyjs");
        var formID = $(this)
            .parent()
            .parent()
            .find("form")
            .attr("id");
        if ($("#" + formID).length) {
            $("#" + formID)
                .parsley()
                .reset();
        }
        //$(".pwd-info-chklist").find("li").removeClass("invalid");
        //$(".pwd-info-chklist").find("li").removeClass("valid");
        //$(".myAccountErrors").removeClass("filled");
        //$(".myAccountErrors").html("");
        //$(".myAccounterrors").removeClass("filled");
        //$(".myAccounterrors").html("");
    }
    catch (ex) {
        console.log(ex);
    }
});

//$(".modal .user-actions .cancel").click(function () {
//    var $ = require("jquery");
//    var parsley = require("parsleyjs");
//    var formID = $(this)
//        .parent()
//        .parent()
//        .closest("form")
//        .attr("id");
//    $("#" + formID).trigger("reset");
//    $("#" + formID)
//        .parsley()
//        .reset();
//    $(".error-box").hide();
//});

//$("#commercial-list .accordianIcon").click(function () {
//    if (
//        $(this)
//            .parent()
//            .parent()
//            .next()
//            .hasClass("in")
//    ) {
//        console.log("hello");
//        $(this)
//            .find(".fa")
//            .addClass("fa-caret-down");
//        $(this)
//            .find(".fa")
//            .removeClass("fa-caret-up");
//    } else {
//        $(this)
//            .find(".fa")
//            .addClass("fa-caret-up");
//        $(this)
//            .find(".fa")
//            .removeClass("fa-caret-down");
//    }
//});

//$(".contact-us-wrapper select").on("change", function (event) {
//            if ($(this).find(':selected').val() == "Choose option") {
//        $(".answer-container").hide();
//    }
//            else {
//                var selectValue = $(this).find(':selected').val();
//    $(".answer-container").hide();
//                    $('[data-contactus="' + selectValue + '"]').show();

//}
//});

},{}],29:[function(require,module,exports){
"use strict";

if ($('.signUp_container').length) {
    $(function () {
        var $sections = $('.form-section');

        function navigateTo(index) {
            // Mark the current section with the class 'current'
            $sections.removeClass('current').eq(index).addClass('current'); // Show only the navigation buttons that make sense for the current section:

            $('.form-navigation .previous').toggle(index > 0);
            var atTheEnd = index >= $sections.length - 1;
            $('.form-navigation .next').toggle(!atTheEnd);
            $('.form-navigation [type=submit]').toggle(atTheEnd);
            $('.form-group .g-recaptcha').toggle(atTheEnd);
            
            fixStepIndicator(index);
        }

        function fixStepIndicator(index) {
            // This function removes the "active" class of all steps...
            var i,
                x = document.getElementsByClassName("step");

            for (i = 0; i < x.length; i++) {
                x[i].className = x[i].className.replace(" active", "");
            } //... and adds the "active" class on the current step:


            if (x[index] != undefined) {
                x[index].className += " active";
            }
        }

        function curIndex() {
            // Return the current index by looking at which section has the class 'current'
            return $sections.index($sections.filter('.current'));
        } // Previous button is easy, just go back


        $('.form-navigation .previous').click(function () {
            navigateTo(curIndex() - 1);
        }); // Next button goes forward iff current block validates

        $('.form-navigation .next').click(function () {
            $('.mstep-form').parsley().whenValidate({
                group: 'block-' + curIndex()
            }).done(function () {
                navigateTo(curIndex() + 1);
            });
        }); // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.

        $sections.each(function (index, section) {
            $(section).find(':input').attr('data-parsley-group', 'block-' + index);
        });
        navigateTo(0); // Start at the beginning
    }); // calender

    $('#today').datepicker({ format: "M dd,yyyy" }).on('change', function () {
        $('.datepicker').hide();
    });

    var todayElement = document.getElementById('today');
    if (todayElement != null) {
        //todayElement.value = moment().format('ll');

        var options = { year: 'numeric', month: 'short', day: 'numeric' };
        todayElement.value = new Date().toLocaleDateString("en-US", options);
    }
}
},{}],30:[function(require,module,exports){
$(document).ready(function () {
    if ($('.sitecore-tel').length) {
        $('.sitecore-tel').mask('(999) 999-9999')
    }
});
},{}],31:[function(require,module,exports){
$(function () {
  var isXS = false,
    $accordionXSCollapse = $('.accordion-xs-collapse');

  // Window resize event (debounced)
  var timer;
  $(window).resize(function () {
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(function () {
      isXS = Modernizr.mq('only screen and (max-width: 991px)');

      // Add/remove collapse class as needed
      if (isXS) {
        $accordionXSCollapse.addClass('collapse');
      } else {
        $accordionXSCollapse.removeClass('collapse');
      }
    }, 100);
  }).trigger('resize'); //trigger window resize on pageload

  // Initialise the Bootstrap Collapse
  $accordionXSCollapse.each(function () {
    $(this).collapse({ toggle: false });
  });

  // Accordion toggle click event (live)
  $(document).on('click', '.accordion-xs-toggle', function (e) {
    e.preventDefault();

    var $thisToggle = $(this),
      $targetRow = $thisToggle.parent('.tr'),
      $targetCollapse = $targetRow.find('.accordion-xs-collapse');

    if (isXS && $targetCollapse.length) {
      var $siblingRow = $targetRow.siblings('.tr'),
        $siblingToggle = $siblingRow.find('.accordion-xs-toggle'),
        $siblingCollapse = $siblingRow.find('.accordion-xs-collapse');

      $targetCollapse.collapse('toggle'); //toggle this collapse
      $siblingCollapse.collapse('hide'); //close siblings

      $thisToggle.toggleClass('collapsed'); //class used for icon marker
      $siblingToggle.removeClass('collapsed'); //remove sibling marker class
    }
  });
});
},{}],32:[function(require,module,exports){




/*!
 * jQuery Browser Plugin v0.0.6
 * https://github.com/gabceb/jquery-browser-plugin
 *
 * Original jquery-browser code Copyright 2005, 2013 jQuery Foundation, Inc. and other contributors
 * http://jquery.org/license

 * Modifications Copyright 2013 Gabriel Cebrian
 * https://github.com/gabceb
 *
 * Released under the MIT license
 *
 * Date: 2013-07-29T17:23:27-07:00

 https://github.com/gabceb/jquery-browser-plugin/blob/master/dist/jquery.browser.js
 */

(function (jQuery, window, undefined) {
  "use strict";

  var matched, browser;

  jQuery.uaMatch = function (ua) {
    ua = ua.toLowerCase();

    var match = /(opr)[\/]([\w.]+)/.exec(ua) ||
      /(chrome)[ \/]([\w.]+)/.exec(ua) ||
      /(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) ||
      /(webkit)[ \/]([\w.]+)/.exec(ua) ||
      /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
      /(msie) ([\w.]+)/.exec(ua) ||
      ua.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(ua) ||
      ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
      [];

    var platform_match = /(ipad)/.exec(ua) ||
      /(iphone)/.exec(ua) ||
      /(android)/.exec(ua) ||
      /(windows phone)/.exec(ua) ||
      /(win)/.exec(ua) ||
      /(mac)/.exec(ua) ||
      /(linux)/.exec(ua) ||
      /(cros)/i.exec(ua) ||
      [];

    return {
      browser: match[3] || match[1] || "",
      version: match[2] || "0",
      platform: platform_match[0] || ""
    };
  };

  matched = jQuery.uaMatch(window.navigator.userAgent);
  browser = {};

  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.version);
  }

  if (matched.platform) {
    browser[matched.platform] = true;
  }

  // These are all considered mobile platforms, meaning they run a mobile browser
  if (browser.android || browser.ipad || browser.iphone || browser["windows phone"]) {
    browser.mobile = true;
  }

  // These are all considered desktop platforms, meaning they run a desktop browser
  if (browser.cros || browser.mac || browser.linux || browser.win) {
    browser.desktop = true;
  }

  // Chrome, Opera 15+ and Safari are webkit based browsers
  if (browser.chrome || browser.opr || browser.safari) {
    browser.webkit = true;
  }

  // IE11 has a new token so we will assign it msie to avoid breaking changes
  if (browser.rv) {
    var ie = "msie";

    matched.browser = ie;
    browser[ie] = true;
  }

  // Opera 15+ are identified as opr
  if (browser.opr) {
    var opera = "opera";

    matched.browser = opera;
    browser[opera] = true;
  }

  // Stock Android browsers are marked as Safari on Android.
  if (browser.safari && browser.android) {
    var android = "android";

    matched.browser = android;
    browser[android] = true;
  }

  // Assign the name and platform variable
  browser.name = matched.browser;
  browser.platform = matched.platform;


  jQuery.browser = browser;
})(jQuery, window);

/*
	Masked Input plugin for jQuery
	Copyright (c) 2007-2011 Josh Bush (digitalbush.com)
	Licensed under the MIT license (http://digitalbush.com/projects/masked-input-plugin/#license)
	Version: 1.3
  https://cloud.github.com/downloads/digitalBush/jquery.maskedinput/jquery.maskedinput-1.3.min.js
*/
(function (a) { var b = (a.browser.msie ? "paste" : "input") + ".mask", c = window.orientation != undefined; a.mask = { definitions: { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, dataName: "rawMaskFn" }, a.fn.extend({ caret: function (a, b) { if (this.length != 0) { if (typeof a == "number") { b = typeof b == "number" ? b : a; return this.each(function () { if (this.setSelectionRange) this.setSelectionRange(a, b); else if (this.createTextRange) { var c = this.createTextRange(); c.collapse(!0), c.moveEnd("character", b), c.moveStart("character", a), c.select() } }) } if (this[0].setSelectionRange) a = this[0].selectionStart, b = this[0].selectionEnd; else if (document.selection && document.selection.createRange) { var c = document.selection.createRange(); a = 0 - c.duplicate().moveStart("character", -1e5), b = a + c.text.length } return { begin: a, end: b } } }, unmask: function () { return this.trigger("unmask") }, mask: function (d, e) { if (!d && this.length > 0) { var f = a(this[0]); return f.data(a.mask.dataName)() } e = a.extend({ placeholder: "_", completed: null }, e); var g = a.mask.definitions, h = [], i = d.length, j = null, k = d.length; a.each(d.split(""), function (a, b) { b == "?" ? (k-- , i = a) : g[b] ? (h.push(new RegExp(g[b])), j == null && (j = h.length - 1)) : h.push(null) }); return this.trigger("unmask").each(function () { function v(a) { var b = f.val(), c = -1; for (var d = 0, g = 0; d < k; d++)if (h[d]) { l[d] = e.placeholder; while (g++ < b.length) { var m = b.charAt(g - 1); if (h[d].test(m)) { l[d] = m, c = d; break } } if (g > b.length) break } else l[d] == b.charAt(g) && d != i && (g++ , c = d); if (!a && c + 1 < i) f.val(""), t(0, k); else if (a || c + 1 >= i) u(), a || f.val(f.val().substring(0, c + 1)); return i ? d : j } function u() { return f.val(l.join("")).val() } function t(a, b) { for (var c = a; c < b && c < k; c++)h[c] && (l[c] = e.placeholder) } function s(a) { var b = a.which, c = f.caret(); if (a.ctrlKey || a.altKey || a.metaKey || b < 32) return !0; if (b) { c.end - c.begin != 0 && (t(c.begin, c.end), p(c.begin, c.end - 1)); var d = n(c.begin - 1); if (d < k) { var g = String.fromCharCode(b); if (h[d].test(g)) { q(d), l[d] = g, u(); var i = n(d); f.caret(i), e.completed && i >= k && e.completed.call(f) } } return !1 } } function r(a) { var b = a.which; if (b == 8 || b == 46 || c && b == 127) { var d = f.caret(), e = d.begin, g = d.end; g - e == 0 && (e = b != 46 ? o(e) : g = n(e - 1), g = b == 46 ? n(g) : g), t(e, g), p(e, g - 1); return !1 } if (b == 27) { f.val(m), f.caret(0, v()); return !1 } } function q(a) { for (var b = a, c = e.placeholder; b < k; b++)if (h[b]) { var d = n(b), f = l[b]; l[b] = c; if (d < k && h[d].test(f)) c = f; else break } } function p(a, b) { if (!(a < 0)) { for (var c = a, d = n(b); c < k; c++)if (h[c]) { if (d < k && h[c].test(l[d])) l[c] = l[d], l[d] = e.placeholder; else break; d = n(d) } u(), f.caret(Math.max(j, a)) } } function o(a) { while (--a >= 0 && !h[a]); return a } function n(a) { while (++a <= k && !h[a]); return a } var f = a(this), l = a.map(d.split(""), function (a, b) { if (a != "?") return g[a] ? e.placeholder : a }), m = f.val(); f.data(a.mask.dataName, function () { return a.map(l, function (a, b) { return h[b] && a != e.placeholder ? a : null }).join("") }), f.attr("readonly") || f.one("unmask", function () { f.unbind(".mask").removeData(a.mask.dataName) }).bind("focus.mask", function () { m = f.val(); var b = v(); u(); var c = function () { b == d.length ? f.caret(0, b) : f.caret(b) }; (a.browser.msie ? c : function () { setTimeout(c, 0) })() }).bind("blur.mask", function () { v(), f.val() != m && f.change() }).bind("keydown.mask", r).bind("keypress.mask", s).bind(b, function () { setTimeout(function () { f.caret(v(!0)) }, 0) }), v() }) } }) })(jQuery);

/*     My Javascript      */


$(document).ready(function () {

  $(".phone").mask("(999) 999-9999");

  /*$('form').parsley();*/
  //$(this).parsley().validate();
  //$(".phone").on('blur focus', function () {
    /*var $ = require('jquery');

    var parsley = require('parsleyjs');
    $(this).parsley().validate();*/
  //});
});
},{}],33:[function(require,module,exports){
//$('#myTab').tabCollapse(); // for the heating gas page.
//$('#myAccountTab').tabCollapse(); // for the my account page.



$('#myTab').tabCollapse({
    tabsClass: 'hidden-sm hidden-xs',
    accordionClass: 'visible-sm visible-xs'
});

$(document).ready(function () {
   
    $(document).on('show.bs.collapse', '.panel-collapse', function () {
        $(this).prev(".panel-heading").addClass("active");
    });

    $(document).on('hide.bs.collapse', '.panel-collapse', function () {
        $(this).prev(".panel-heading").removeClass("active");
    });

    if (!window.location.href.includes("q=")) {
        if (window.location.hash.length > 0) {

            if ($(window.location.hash + '-collapse').length) {
                $(window.location.hash + '-collapse').collapse('show');
                window.location.hash = window.location.hash + '-collapse';
            }
        }
    }
});



},{}],34:[function(require,module,exports){
var customModal = require("../../../../feature/LegacyServiceIntercept/code/scripts/customModal.js");
var forms = require("./Components/Feature/Forms/Forms.js"); // ?? maybe that should be packaged with email forms js 
var signup_form = require("./Components/Feature/Forms/signup-form.js"); // ?? maybe that should be packaged with email forms js
var tab_container = require("./Components/Feature/Page Content/tab-container.js");
var download_list = require("./Components/Feature/Page Content/icon-grid.js");
var contact_us = require("./Components/Feature/Forms/contact-us.js"); 
var phone_field = require("./Components/Feature/Page Content/phone-field.js"); // this file has some third party libs, could be packaged it with vendor.js

var login = require("../../../../Feature/PageContent/code/Scripts/Login.js"); 

var calculator = require("../../../../Feature/PageContent/code/Scripts/Calculator.js");

var accessibilityNavigation = require("../../../../Project/Extranet/code/js/accessibility-navigation.js"); 


var globalNotification = require("../../../../Feature/PageContent/code/Scripts/GlobalNotification.js"); 
var cozEchatBot = require("../../../../Feature/PageContent/code/Scripts/cozE-Chatbot.js"); 

var serviceIntercept = require("../../../../feature/LegacyServiceIntercept/code/scripts/ServiceIntercept.js"); 
var breadCrumb = require("../../../../feature/Navigation/code/scripts/BreadCrumb.js"); 
var primaryNavigation = require("../../../../feature/Navigation/code/scripts/PrimaryHeaderNavigation.js"); 
var sarniaPopupMessage = require("../../../../feature/Navigation/code/scripts/SarniaPopupMessage.js");
var faq = require("../../../../feature/PageContent/code/scripts/Faq.js");
var trafficLights = require("../../../../feature/TrafficLights/code/scripts/TrafficLights.js");
var opStatus = require("../../../../feature/TrafficLights/code/scripts/OperationalStatusIcon.js");

var accordion = require("../../../../feature/PageContent/code/scripts/Accordion.js"); 

var serviceAreaValidate = require("../../../../feature/ServiceAreaLookup/code/scripts/ServiceAreaValidate.js"); 
var newsRoom = require("../../../../feature/PageContent/code/scripts/NewsRoom.js"); 
var rateLookup = require("../../../../feature/RateLookup/code/scripts/RateLookup.js"); 
var stickyNavigation = require("../../../../feature/Navigation/code/scripts/StickyNavigation.js"); 
var stickyNavigation = require("../../../../feature/Navigation/code/scripts/HeaderGeoLocation.js");
var timeline = require("../../../../feature/PageContent/code/scripts/Timeline.js"); 
var verticalTab = require("../../../../feature/PageContent/code/scripts/VerticalTab.js");
var contactUs = require("../../../../feature/PageContent/code/scripts/ContactUs.js"); 
var sitecore_forms = require("./Components/Feature/Forms/sitecore-forms.js"); 
var Carousel = require("../../../../feature/PageContent/code/scripts/CarouselHeroImage.js"); 
var Alert = require("../../../../feature/PageContent/code/scripts/Alert.js"); 
var InfoPost = require("../../../../Feature/InfoPost/code/Scripts/InfoPostNotice.js");
var Contentlisting = require("../../../../feature/PageContent/code/scripts/ContentListing.js");
},{"../../../../Feature/InfoPost/code/Scripts/InfoPostNotice.js":1,"../../../../Feature/PageContent/code/Scripts/Calculator.js":2,"../../../../Feature/PageContent/code/Scripts/GlobalNotification.js":3,"../../../../Feature/PageContent/code/Scripts/Login.js":4,"../../../../Feature/PageContent/code/Scripts/cozE-Chatbot.js":5,"../../../../Project/Extranet/code/js/accessibility-navigation.js":6,"../../../../feature/LegacyServiceIntercept/code/scripts/ServiceIntercept.js":7,"../../../../feature/LegacyServiceIntercept/code/scripts/customModal.js":8,"../../../../feature/Navigation/code/scripts/BreadCrumb.js":9,"../../../../feature/Navigation/code/scripts/HeaderGeoLocation.js":10,"../../../../feature/Navigation/code/scripts/PrimaryHeaderNavigation.js":11,"../../../../feature/Navigation/code/scripts/SarniaPopupMessage.js":12,"../../../../feature/Navigation/code/scripts/StickyNavigation.js":13,"../../../../feature/PageContent/code/scripts/Accordion.js":14,"../../../../feature/PageContent/code/scripts/Alert.js":15,"../../../../feature/PageContent/code/scripts/CarouselHeroImage.js":16,"../../../../feature/PageContent/code/scripts/ContactUs.js":17,"../../../../feature/PageContent/code/scripts/ContentListing.js":18,"../../../../feature/PageContent/code/scripts/Faq.js":19,"../../../../feature/PageContent/code/scripts/NewsRoom.js":20,"../../../../feature/PageContent/code/scripts/Timeline.js":21,"../../../../feature/PageContent/code/scripts/VerticalTab.js":22,"../../../../feature/RateLookup/code/scripts/RateLookup.js":23,"../../../../feature/ServiceAreaLookup/code/scripts/ServiceAreaValidate.js":24,"../../../../feature/TrafficLights/code/scripts/OperationalStatusIcon.js":25,"../../../../feature/TrafficLights/code/scripts/TrafficLights.js":26,"./Components/Feature/Forms/Forms.js":27,"./Components/Feature/Forms/contact-us.js":28,"./Components/Feature/Forms/signup-form.js":29,"./Components/Feature/Forms/sitecore-forms.js":30,"./Components/Feature/Page Content/icon-grid.js":31,"./Components/Feature/Page Content/phone-field.js":32,"./Components/Feature/Page Content/tab-container.js":33}]},{},[34]);
